import { updateMemberInfo } from '../actions/userActions'

export default {
  appVersion: '1.0.2.20190917.1653',
  image: {
    upload: {
      url: `${window.baseURL}api/file/create`,
    },
  },
  bannerManager: {
    impressions: {
      url: `${window.baseURL}graphql`,
      query: `mutation createBannerImpression($BannerID: Int!, $ImpressionType: String!) {
        createBannerImpression(BannerID: $BannerID, ImpressionType: $ImpressionType) {
          ID
          Clicks
          Impressions
        }
      }`,
    },
  },
  authentication: {
    // url: `${window.baseURL}producthelper/readmemberinfo/`,
    url: `${window.baseURL}graphql-core`,
    query: `query {
          readCurrentMember(PurchasingUser: {PurchasingUser}) {
            ID
            InternalItemID
            Is3PL
            Is3PLMEL
            DelayedPopupCount
            Is3PLSYD
            Is3PLCAI
            Is3PLADE
            Is3PLBRIS
            DefaultLocationForSupplier
            TempIDHash
            FirstName
            Company
            Surname
            Email
            Gender
            Mobile
            LoyaltyEnabled
            EnState
            EnLocationID
            IsConsolidationEnabled
            NotifyRestockViaSMS
            NotifyRestockViaEmail
            AccountReminderViaSMS
            HideQLDCustomerPopup
            DiscountSyncing
            LoyaltyStatus
            CalculatedTotalLoyaltyPoints
            DP_FirstName
            DP_Surname
            DP_ContactNumber
            DP_Email
            DP_PreferredDeliveryDay
            DP_PreferredDeliveryTimes
            BN_FirstName
            BN_Surname
            BN_ContactNumber
            BN_Email
            FD_FirstName
            FD_Surname
            FD_ContactNumber
            FD_Email
            AP_FirstName
            AP_Surname
            AP_ContactNumber
            AP_Email
            SurveyDisplayCount
            HideFreightIncreaseNotification
            ChargeArea
            HidePopup
            SubUserData
            UserRole
            DeliveryAddress {
              ... on Address {
                ID
                State
              }
            }
            BillingAddress {
              ... on Address {
                ID
              }
            }
            SavedCreditCard {
              ... on ElvantiSavedCreditCard {
                ID
              }
            }
            ChildSavedCreditCard{
              ... on ElvantiSavedCreditCard{
               ID
             }
            }
            MainAccount
            Parent {
              ... on member {
                ID
              }
            }
          }
        }`,
  },
  readSubChildrenAccount: {
    // url: `${window.baseURL}producthelper/readmemberinfo/`,
    url: `${window.baseURL}graphql-core`,
    query: `query {
      readSubChildrenAccount {
        ID
        Is3PL
        Is3PLMEL
        Is3PLSYD
        Is3PLCAI
        Is3PLADE
        Is3PLBRIS
        DefaultLocationForSupplier
        TempIDHash
        FirstName
        Company
        UserRole
        Surname
        Email
        Gender
        Mobile
        LoyaltyEnabled
        EnState
        EnLocationID
        IsConsolidationEnabled
        NotifyRestockViaSMS
        NotifyRestockViaEmail
        AccountReminderViaSMS
        HideQLDCustomerPopup
        DiscountSyncing
        LoyaltyStatus
        CalculatedTotalLoyaltyPoints
        DP_FirstName
        DP_Surname
        DP_ContactNumber
        DP_Email
        DP_PreferredDeliveryDay
        DP_PreferredDeliveryTimes
        BN_FirstName
        BN_Surname
        BN_ContactNumber
        BN_Email
        FD_FirstName
        FD_Surname
        FD_ContactNumber
        FD_Email
        AP_FirstName
        AP_Surname
        AP_ContactNumber
        AP_Email
        SurveyDisplayCount
        HideFreightIncreaseNotification
        ChargeArea
      }}`,
  },
  readGlobalConfig: {
    url: `${window.baseURL}graphql`,
    query: `{
        readGlobalConfig {
          CheckoutPaymentMethods
          InvoicePaymentMethods
          UseCurrentCards
          ProductTypes
          ProductBrands
          ProductCategory
          ProductVarietals
          ProductStyles
          LastUsedPaymentMethod
          UserTermType
          CategoryTopFilters
          ThreePLLocations
          EnableCPI
          HideBackOrderSuppliers
        }
      }`,
  },

  triggerDiscount: {
    url: `${window.baseURL}graphql-enterprise`,
    query: `mutation ($ID: ID) {
      triggerDiscountSync(ID: $ID) {
        ID
      }
    }`,
  },
  authenticationGraphQL: {
    url: `${window.baseURL}graphql`,
    query: `{
            readElvantiElasticMemberInfos {
                edges {
                    node {
                        MemberID
                        MemberTempHash
                        GroupID
                    }
                }
            }
        }`,
  },
  payments: {
    makeapayment: {
      // url: `${window.baseURL}payments/makepayment`
      url: `${window.baseURL}graphql-enterprise`,
      query: `mutation payForParamountInvoices($InvoiceIDs: [ID], $Amount: Float!, $CardID: ID!, $PaymentMethod: String!, $Gateway: String!) {
                payForParamountInvoices(InvoiceIDs: $InvoiceIDs, Amount: $Amount, CardID: $CardID, PaymentMethod: $PaymentMethod, Gateway: $Gateway) {
                    ID
                    PaymentRedirectURL
                }
            }`,
    },
    applyInvoiceCreditCardSurcharge: {
      url: `${window.baseURL}graphql-enterprise`,
      query: `mutation applyInvoiceCreditCardSurcharge($InvoiceIDs: [Int], $Amount: Float!, $SavedCardID: Int!, $PaymentMethod: String!) {
                applyInvoiceCreditCardSurcharge(Filters: {InvoiceIDs: $InvoiceIDs, Amount: $Amount, SavedCardID: $SavedCardID, PaymentMethod: $PaymentMethod}) {
                  TotalDue
                  TotalSurcharge
                  Total
                }
            }`,
    },
    listing: {
      url: `${window.baseURL}graphql`,
      query: `{
                readSilverStripePayments {
                    edges {
                        node {
                            ID
                            Created
                            Gateway
                            Amount
                            Status
                            Identifier
                            TransactionReference
                        }
                    }
                }
            }`,
    },
  },
  filters: {
    list: {
      url: `${window.baseURL}graphql-product`,
      query: `query productFilters(
        $q: String
        $CategoryURL: String
        $ContainerType: [String]
        $Varietal: [String]
        $LiquorStyle: [String]
        $Brand: [String]
        $Country: [String]
        $Region: [String]
        $LoyaltyPoints: [String]
      ) {
        productFilters(
          q: $q
          CategoryURL: $CategoryURL
          ContainerType: $ContainerType
          Varietal: $Varietal
          LiquorStyle: $LiquorStyle
          Brand: $Brand
          Country: $Country
          Region: $Region
          LoyaltyPoints: $LoyaltyPoints
        ) {
          Title
          Items
          DisplayTitle
          IsCollapsed
          FilterSort
        }
      }`,
    },

    brands: {
      url: `${window.baseURL}st/?action=GetFilters&filter=Brand&catid={category}&limit=9999`,
    },
    countries: {
      url: `${window.baseURL}st/?action=GetFilters&filter=Country&catid={category}&limit=9999`,
    },
    regions: {
      url: `${window.baseURL}st/?action=GetFilters&filter=Region&catid={category}&limit=9999`,
    },
    styles: {
      url: `${window.baseURL}st/?action=GetFilters&filter=Style&catid={category}&limit=9999`,
    },
    types: {
      url: `${window.baseURL}st/?action=GetFilters&filter=PType&catid={category}&limit=9999`,
    },
    varietal: {
      url: `${window.baseURL}st/?action=GetFilters&filter=Varietal&catid={category}&limit=9999`,
    },
  },
  categories: {
    listNames: {
      url: `${window.baseURL}producthelper/getcategories/?catIDS={ids}`,
    },
  },
  products: {
    readProductAllocation: {
      url: `${window.baseURL}graphql-product`,
      query: `query($MemberID: Int){
        readProductAllocation(MemberID: $MemberID){
          MinValue
          MaxValue
          BuyableID
          StartDate
          EndDate
        }
      }`,
    },
    notificationListing: {
      //url: `${window.baseURL}enterprise/readbuyablesinorder/?type=Order Template`,
      url: `${window.baseURL}graphql`,
      query: `{
               readRemindMeProducts {
                   ID
                }
            }`,
    },
    notificationToggle: {
      //url: `${window.baseURL}enterprise/readbuyablesinorder/?type=Order Template`,
      url: `${window.baseURL}graphql`,
      query: `mutation ($ProductID:Int! ,$RemindMe:Boolean!){
                RemindMeProductMutation(ProductID:$ProductID,RemindMe:$RemindMe) {
                  RemindMe
                }
            }`,
    },
    listingPerPage: {
      url: `${window.baseURL}graphql-product`,
      query: `{
                searchResult({params}) {
                    pageInfo {
                        totalCount
                        hasNextPage
                        hasPreviousPage
                    }
                    edges {
                        node {
                            MiraklProduct
                            ContainerType
                            ProductType
                            ID
                            Title
                            URLSegment
                            InternalItemID
                            Brand
                            Varietal
                            LiquorStyle
                            BrandRegion
                            BrandCountry
                            DisplayRRP
                            DisplayPrice
                            ReSizedDefaultImage
                            ReSizedProductListingImage
                            UnitRRP
                            UnitPrice
                            CaseRRP
                            CasePrice
                            SoldAt
                            StockForMelbourne
                            StockForSydney
                            StockForAdelaide
                            StockForBrisbane
                            StockForCairns
                            CombinedStock
                            TranslationRedemptionID
                            WholesaleUnitsPerCase
                            ItemsInCase
                            SellByPackageOnly
                            WebCategory
                            Created
                            EnCreated
                            HasCocktails
                            LoyaltyPoints
                            SupplierLoyaltyPoints
                            BonusLoyaltyPoints
                            PointsExcludedFromRetail
                            WetTax
                            SplitPackSize
                            CaseCostMelbourne
                            CaseCostSydney
                            CaseCostAdelaide
                            CaseCostBrisbane
                            CaseCostCairns
                            SplitCaseSurchargesJSON
                            IsCoreRange
                            Supplier
                            SupplierExternalID
                            LongtermOOS {
                              edges {
                                node {
                                  ID
                                  Location {
                                    ID
                                  }
                                  Date
                                }
                              }
                            }

                        }
                    }
                }
            }`,
    },
    idtimestamp: {
      //url: `${window.baseURL}st/?action=FilterProducts&catid={category}&ids_and_modified=1&limit=9999`,
      url: `${window.baseURL}graphql-product`,
    },
    filters: {
      url: `${window.baseURL}st/?action=FilterProducts&catid={category}&limit={amount}&offset={startingIndex}`,
      // url: `${window.baseURL}st/filterproducts/{groupID}/{category}/{brands}/{regions}/{countries}`,
    },
    listingSupplier: {
      //url: `${window.baseURL}st/?action=productsBySupplierID&supid={supplierExternalID}&limit={amount}&offset={startingIndex}`,
      // url: `${window.baseURL}st/supplierproducts/{user}/{base_group}/{key}`,
      url: `${window.baseURL}graphql-product`,
      query: `{
                searchResult({params}) {
                    pageInfo {
                        totalCount
                        hasNextPage
                        hasPreviousPage
                    }
                    edges {
                        node {
                            MiraklProduct
                            ContainerType
                            ProductType
                            ID
                            Title
                            URLSegment
                            InternalItemID
                            Brand
                            Varietal
                            LiquorStyle
                            BrandRegion
                            BrandCountry
                            DisplayRRP
                            DisplayPrice
                            ReSizedDefaultImage
                            ReSizedProductListingImage
                            UnitRRP
                            UnitPrice
                            CaseRRP
                            CasePrice
                            SoldAt
                            StockForMelbourne
                            StockForSydney
                            StockForAdelaide
                            StockForBrisbane
                            StockForCairns
                            WholesaleUnitsPerCase
                            ItemsInCase
                            SellByPackageOnly
                            WebCategory
                            Created
                            EnCreated
                            HasCocktails
                            LoyaltyPoints
                            SupplierLoyaltyPoints
                            BonusLoyaltyPoints
                            PointsExcludedFromRetail
                            WetTax
                            SplitPackSize
                            CasesPerLayer
                            CasesPerPallet
                            ItemWeight
                            MLPerunit
                            SplitCaseSurchargesJSON
                            IsCoreRange
                        }
                    }
                }
            }`,
    },
    readProductMaintenancePrices: {
      url: `${window.baseURL}graphql-product`,
      query: ` query {
        readProductMaintenancePrices {
          BuyableID
          PriceAdl
          PriceBris
          PriceMel
          PriceSyd
          PriceCns
        }
      }`,
    },
    createProductMaintenancePrice: {
      url: `${window.baseURL}graphql-product`,
      query: `mutation createProductMaintenancePrice(
        $Input: [ProductMaintenancePricesInputType]
      ) {
        createProductMaintenancePrice(Input: $Input) {
          Status
        }
      }`,
    },

    pricesSupplier: {
      url: `${window.baseURL}st/?action=SupplierProductPrices&process_response=1&memberid={user}&limit=9999&productids={productIDs}`,
      // url: '../../action/dashboard/TEMP__requestProductPrices.php',
      // url: `${window.baseURL}st/suppliermemberprices/{user}/{key}`,
    },
    frontlinePricesSupplier: {
      url: `${window.baseURL}st/?action=SupplierProductPrices&process_response=1&frontlineonly=1&limit=9999&productids={productIDs}`,
    },
    detailsByVariationID: {
      url: `${window.baseURL}st/?action=ProductsByVariationID&ids={productIDs}`,
      // url: `${window.baseURL}st/memberproductbyid/{user}/{base_group}/{productID}/{key}`,
    },
    prductDetails: {
      // url: `${window.baseURL}st/?action=ProductsByID&ids={productIDs}&limit=700`,
      // url: `${window.baseURL}st/memberproductbyid/{user}/{base_group}/{productID}/{key}`,
      url: `${window.baseURL}graphql-product`,
      query: `query readProducts($InternalItemIDs: [Int!]) {
              readProducts(Filters: {InternalItemIDs: $InternalItemIDs}) {
                pageInfo {
                  totalCount
                  hasNextPage
                  hasPreviousPage
                }
                edges {
                  node {
                    ID
                    Title
                    URLSegment
                    InternalItemID
                    Brand
                    Varietal
                    LiquorStyle
                    BrandRegion
                    BrandCountry
                    DisplayRRP
                    DisplayPrice
                    ReSizedDefaultImage
                    ReSizedProductListingImage
                    UnitRRP
                    UnitPrice
                    CaseRRP
                    CasePrice
                    SoldAt
                    StockForMelbourne
                    StockForSydney
                    StockForAdelaide
                    StockForBrisbane
                    StockForCairns
                    CombinedStock
                    TranslationRedemptionID
                    WholesaleUnitsPerCase
                    ItemsInCase
                    SellByPackageOnly
                    WebCategory
                    Created
                    EnCreated
                    HasCocktails
                    LoyaltyPoints
                    SupplierLoyaltyPoints
                    BonusLoyaltyPoints
                    PointsExcludedFromRetail
                    WetTax
                    SplitPackSize
                    ContainerType
                    ProductType
                    SplitCaseSurchargesJSON
                    IsCoreRange
                    Supplier
                    SupplierExternalID
                    LongtermOOS {
                      edges {
                        node {
                          ID
                          Location {
                            ID
                          }
                          Date
                        }
                      }
                    }
                  }
                }
              }
            }`,
    },

    details: {
      // url: `${window.baseURL}st/?action=ProductsByID&ids={productIDs}&limit=700`,
      // url: `${window.baseURL}st/memberproductbyid/{user}/{base_group}/{productID}/{key}`,
      url: `${window.baseURL}graphql-product`,
      query: `query readProducts($IDs: [Int!]) {
              readProducts(Filters: {IDs: $IDs}) {
                pageInfo {
                  totalCount
                  hasNextPage
                  hasPreviousPage
                }
                edges {
                  node {
                    MiraklProduct
                    ID
                    Title
                    Abv
                    URLSegment
                    InternalItemID
                    Brand
                    Varietal
                    LiquorStyle
                    BrandRegion
                    BrandCountry
                    CaseCostAdelaide
                    CaseCostMelbourne
                    CaseCostSydney
                    CaseCostBrisbane
                    CaseCostCairns
                    DisplayRRP
                    DisplayPrice
                    ReSizedDefaultImage
                    ReSizedProductListingImage
                    UnitRRP
                    UnitPrice
                    CaseRRP
                    CasePrice
                    SoldAt
                    StockForMelbourne
                    StockForSydney
                    StockForAdelaide
                    StockForBrisbane
                    StockForCairns
                    CombinedStock
                    TranslationRedemptionID
                    WholesaleUnitsPerCase
                    ItemsInCase
                    SellByPackageOnly
                    WebCategory
                    Created
                    EnCreated
                    HasCocktails
                    LoyaltyPoints
                    SupplierLoyaltyPoints
                    BonusLoyaltyPoints
                    PointsExcludedFromRetail
                    WetTax
                    SplitPackSize
                    Sort
                    ContainerType
                    ProductType
                    Supplier
                    SupplierExternalID
                    SplitCaseSurchargesJSON
                    IsCoreRange
                    LongtermOOS {
                      edges {
                        node {
                          ID
                          Location {
                            ID
                          }
                          Date
                        }
                      }
                    }
                  }
                }
              }
            }`,
    },
    listing: {
      //url: `${window.baseURL}st/?action=@@@FilterProducts&sortBy=SortableTitle:asc`,
      url: `${window.baseURL}graphql-product`,
      query: `{
                searchResult({params}) {
                    pageInfo {
                        totalCount
                        hasNextPage
                        hasPreviousPage
                    }
                    edges {
                        node {
                            MiraklProduct
                            ContainerType
                            ProductType
                            ID
                            Title
                            URLSegment
                            InternalItemID
                            Brand
                            Varietal
                            LiquorStyle
                            BrandRegion
                            BrandCountry
                            DisplayRRP
                            DisplayPrice
                            ReSizedDefaultImage
                            ReSizedProductListingImage
                            UnitRRP
                            UnitPrice
                            CaseRRP
                            CasePrice
                            SoldAt
                            StockForMelbourne
                            StockForSydney
                            StockForAdelaide
                            StockForBrisbane
                            StockForCairns
                            CombinedStock
                            TranslationRedemptionID
                            ItemsInCase
                            WebCategory
                            Created
                            LoyaltyPoints
                            SupplierLoyaltyPoints
                            BonusLoyaltyPoints
                            SplitPackSize
                            SplitCaseSurchargesJSON
                            IsCoreRange
                            Supplier
                            SupplierExternalID
                            LongtermOOS {
                              edges {
                                node {
                                  ID
                                  Location {
                                    ID
                                  }
                                  Date
                                }
                              }
                            }
                        }
                    }
                }
            }`,
    },
    newArrival: {
      url: `${window.baseURL}st/?action=NewArrivalProducts&limit={amount}&offset={startingIndex}`,
      // url: `${window.baseURL}st/products/{groupID}/{category}/{startingIndex}/{amount}`,
    },
    newArrivalIDOnly: {
      url: `${window.baseURL}st/?action=NewArrivalProducts&limit=9999&idsonly=1`,
    },
    onSpecials: {
      url: `${window.baseURL}st/?action=OnSpecialProducts&limit={amount}&offset={startingIndex}`,
    },
    onSpecialsIDOnly: {
      url: `${window.baseURL}st/?action=OnSpecialProducts&limit=9999&idsonly=1`,
    },
    prices: {
      // url: `${window.baseURL}st/?action=ProductPrices&process_response=1&limit=9999&productids={productIDs}`,
      url: `${window.baseURL}graphql-product`,
      query: `query readProductPrices($MemberID: Int, $BuyableIDs: [Int]!) {
              readProductPrices(MemberID: $MemberID, BuyableIDs: $BuyableIDs) {
                Discount
                BuyableID
                UnitPrice
                CasePrice
                DiscountedCasePrice
              }
            }`,
      // query: `query readCustomerDiscounts($ProductIDs: [ID]) {
      //   readCustomerDiscounts(Filters: { ProductIDs: $ProductIDs }) {
      //     edges {
      //       node {
      //         ID
      //         Discount
      //         Discount2
      //         ProductExternalID
      //         CustomerExternalID
      //         Product {
      //           ... on Product {
      //             ID
      //             Title
      //             UnitPrice
      //             CasePrice
      //           }
      //         }
      //       }
      //     }
      //   }
      // }`
    },
    enCustomerDiscounts: {
      url: `${window.baseURL}graphql-product`,
      query: `query readEnCustomerDiscounts($MemberID: Int) {
        readEnCustomerDiscounts(MemberID: $MemberID) {
            IsDiscountSyncing
            Discounts
            PromoDeals
        }
      }`,
    },
    refreshEnCustomerDiscounts: {
      url: `${window.baseURL}graphql-product`,
      query: `query refreshEnCustomerDiscounts($MemberID: Int) {
        refreshEnCustomerDiscounts(MemberID: $MemberID)
      }`,
    },
    promotions: {
      url: `${window.baseURL}st/?action=GetPromotions&productids={productID}&process_response=1`,
      // url: `${window.baseURL}graphql`,
      // query: `{
      //     readElvantiProductPromotions(productid: {productID}, groupid: {groupID}) {
      //         edges {
      //             node {
      //                 ID,
      //                 Title,
      //                 Description
      //             }
      //         }
      //     }
      // }`
    },
    replacements: {
      url: `${window.baseURL}graphql-product`,
      query: `query ($ProductID: ID!, $TotalUnitItems: Int, $limit: Int, $offset: Int, $Sort: String) {
                readSubstituteProducts(ProductID: $ProductID, TotalUnitItems: $TotalUnitItems, limit: $limit, offset: $offset, Sort: $Sort) {
                    edges {
                        node {
                            Brand
                            BrandCountry
                            BrandRegion
                            CasePrice
                            CaseRRP
                            DisplayPrice
                            DisplayRRP
                            ID
                            InternalItemID
                            ItemsInCase
                            LiquorStyle
                            LoyaltyPoints
                            ReSizedDefaultImage
                            ReSizedProductListingImage
                            SellByPackageOnly
                            SoldAt
                            StockForAdelaide
                            StockForMelbourne
                            StockForSydney
                            StockForBrisbane
                            StockForCairns
                            SupplierLoyaltyPoints
                            BonusLoyaltyPoints
                            Title
                            UnitPrice
                            UnitRRP
                            URLSegment
                            Varietal
                            WebCategory
                            WholesaleUnitsPerCase
                            ContainerType
                            ProductType
                        }
                    }
                }
            }`,
    },
    related: {
      url: `${window.baseURL}graphql-product`,
      query: `query ($ProductID: ID!, $TotalUnitItems: Int, $limit: Int, $offset: Int, $Sort: String) {
                readRelatedProducts(ProductID: $ProductID, TotalUnitItems: $TotalUnitItems, limit: $limit, offset: $offset, Sort: $Sort) {
                    edges {
                        node {
                            ID
                            Title
                            URLSegment
                            InternalItemID
                            Brand
                            Varietal
                            LiquorStyle
                            BrandRegion
                            BrandCountry
                            DisplayRRP
                            DisplayPrice
                            ReSizedDefaultImage
                            ReSizedProductListingImage
                            UnitRRP
                            UnitPrice
                            CaseRRP
                            CasePrice
                            SoldAt
                            StockForMelbourne
                            StockForSydney
                            StockForAdelaide
                            StockForBrisbane
                            StockForCairns
                            WholesaleUnitsPerCase
                            ItemsInCase
                            SellByPackageOnly
                            WebCategory
                            ContainerType
                            ProductType
                        }
                    }
                }
            }`,
    },
    hasCocktails: {
      //url: `${window.baseURL}producthelper/hascocktail/?productIDS={productIDs}`,
      url: `${window.baseURL}graphql-product`,
      query: `
                query ($IDs: [Int]) {
                  readProducts (Filters: {IDs: $IDs}){
                    edges {
                      node {
                        ID
                        Title
                        HasCocktails
                      }
                    }
                  }
                }`,
    },
  },
  cocktails: {
    details: {
      url: `${window.baseURL}graphql-product`,
      query: `query ($ID: Int!) {
                readOneCocktail (ID: $ID) {
                    ID
                    Title
                    CocktailListingImage
                    CocktailDetailImage
                    CocktailThumbnailImage
                    URLSegment
                    Excerpt
                    ProductsID
                    IngredientsTitle
                }
            }`,
    },
    listing: {
      url: `${window.baseURL}graphql-product`,
      query: `query ($ID: Int, $ProductID: Int) {
                readCocktails (ID: $ID, ProductID: $ProductID) {
                    edges {
                        node {
                            ID
                            Title
                            CocktailListingImage
                            CocktailDetailImage
                            URLSegment
                            Excerpt
                            ProductsID
                        }
                    }
                }
            }`,
    },
  },
  invoices: {
    listingParamount: {
      url: `${window.baseURL}graphql-enterprise`,
      query: `query ReadInvoices {
              readParamountInvoices {
                edges {
                  node {
                    ID
                    InvoiceID
                    CustomerID
                    TranslationInvoiceNum
                    Status
                    ParamountStatus
                    Receipt
                    InvoiceTotal
                    PrintedSignature
                    TimeEntered
                    Locked
                    Parent10
                    InvoiceNum
                    DueDate
                    OpenDebit
                    PONum
                    TimeCreated
                    Date
                    InvoiceStatus
                  }
                }
              }
            }`,
    },
    listing: {
      url: `${window.baseURL}graphql-enterprise`,
      query: `query ($Status: [String]) {
              readInvoices(Filters: { Status: $Status }) {
                ID
                ExternalItemID
                DeliveryDate
                Status
                ParamountStatusNumber
                DueDate
                Receipt
                InvoiceAmount
                PONum
                OrderID
                Locked
                InvoiceNum
                TotalCases
                TotalDue
                IsPreAuthInvoice
              }
            }`,
    },
    search: {
      url: `${window.baseURL}graphql`,
      query: `query($InvoiceNum: [String!]) {
        searchInvoice(InvoiceNum: $InvoiceNum) {
          ID
          PONum
          OrderID
          InvoiceNum
          CustomerName
          DeliveryDate
          Status
          InvoiceAmount
          ExternalItemID
          PODLinks {
            ID
            InvoiceID
            PODLink
          }
        }
      }`,
    },
    listingUnpaid: {
      url: `${window.baseURL}graphql-enterprise`,
      query: `query ($Status: String) {
              readInvoices(Filters: {Status: [$Status]}) {
                ID
                Status
                Pending
                Paid
                TotalDue
                DueDate
                OrderID
                PaidDate
                InternalItemID
                ExternalItemLink
                ExternalDateCreated
                DeliveryDate
                InvoiceAmount
                OrderID
                TotalCases
                IsPreAuthInvoice
              }
            }`,
    },
    details: {
      url: `${window.baseURL}graphql`,
      query: `{
                readElvantiInvoices(memberid: {userID}, id: {orderID}) {
                    edges {
                        node {
                            ID
                            InvoiceDate
                            DeliveryDate
                            Status
                            Reference
                            Total
                            Paid
                            InvoiceDueDate
                            Order {
                                __typename
                                ... on ElvantiOrder {
                                    ID
                                    Created
                                    DeliveryDate
                                    Status
                                    Reference
                                    Total
                                    TaxTotal
                                    OrderItems {
                                        edges {
                                            node {
                                                ID
                                                BuyableID
                                                Title
                                                UnitPrice
                                                UnitQuantity
                                                CasePrice
                                                CaseQuantity
                                                TotalPrice
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }`,
    },
    balance: {
      url: `${window.baseURL}graphql-enterprise`,
      query: `query readMemberInvoiceBalance {
        readMemberInvoiceBalance {
          TotalDue
          TotalBalance
        }
      }`,
    },
  },
  orders: {
    listing: {
      url: `${window.baseURL}graphql`,
      query: `{
                readElvantiOrders(memberid: {userID}) {
                    edges {
                        node {
                            ID
                            Placed
                            Total
                            Status
                            DeliveryDate
                            Reference
                            Shipped
                        }
                    }
                }
            }`,
    },
    listing3pl: {
      url: `${window.baseURL}graphql`,
      query: `{
                readElvantiOrders(memberid: {memberID}, plcustomerid: {customerID}) {
                    edges {
                        node {
                            ID
                            Placed
                            DeliveryDate
                            Reference
                            Status
                            Total
                            PlCustomer {
                                Name
                                Suburb
                            },
                            OrderItems {
                                edges {
                                    node {
                                        BuyableID,
                                        Title,
                                        TotalPrice,
                                        SellByPackageOnly,
                                        ConsumableUnitsPerCase,
                                        UnitQuantity,
                                        CaseQuantity,
                                        CasePrice,
                                        UnitPrice,
                                        InternalItemID
                                    }
                                }
                            }
                        }
                    }
                }
            }`,
    },
    details: {
      url: `/graphql-enterprise`,
      query: `query ReadOneCartOrder($Filters: CartOrderFilterInput!) {
          readCartOrders(Filters: $Filters) {
              edges {
              node {
                  Total
                  TaxTotal
                  SubTotal
                  DiscountTotal
                  ShippingTotal
                  Items {
                      edges {
                              node
                              {
                                  Title
                                  TotalPrice
                                  TotalUnitItems
                                  DisplayImage
                                  BundleType
                                  ID

                              }
                          }
                      }
                  }
              }
          }

      }`,
    },
    reorder: {
      url: `/graphql-enterprise`,
      query: `mutation($Buyables: [CartItemInput]!) {
      addCartOrderItems(Buyables: $Buyables) {
        ID
        Items {
          edges {
            node {
              UnitPrice
              TotalPriceWithoutTax
              UnitTax
              Packagetax
              TotalPrice
              ID
              Title
              InternalItemID
              ExternalItemID
              DisplayImage
              ItemsInPackage
              SoldInQuantity
              TotalUnitItems
              SupplierPromotionDiscount
              SupplierPromotionType
              TotalPackageItems
              TotalItems
              CalculatedUnitPrice
              CalculatedPackagePrice
              CalculatedTotalPrice
              CalculatedUnitTax
              CalculatedPackageTax
              CalculatedTotalTax
              IsTaxable
              LockItem
              IsBundleItem
              Notes
            }
          }
        }
      }
    }`,
    },
    receiptDetails: {
      url: `${window.baseURL}graphql`,
      query: `{
                readElvantiOrders(id: {id}) {
                    edges {
                        node {
                            ID
                            Placed
                            DeliveryDate
                            Reference
                            Status
                            TaxTotal
                            Total
                            ShippingTotal
                            OrderItems {
                                edges {
                                    node {
                                        BuyableID,
                                        Title,
                                        TotalPrice,
                                        SellByPackageOnly,
                                        ConsumableUnitsPerCase,
                                        UnitQuantity,
                                        CaseQuantity,
                                        CasePrice,
                                        UnitPrice,
                                        InternalItemID
                                    }
                                }
                            }
                        }
                    }
                }
            }`,
    },
  },
  orderTemplate: {
    listing: {
      //url: `${window.baseURL}enterprise/readbuyablesinorder/?type=Order Template`,
      url: `${window.baseURL}graphql-product`,
      query: `{
                readOrderTemplate {
                    edges {
                        node {
                            ID
                            BuyableID
                        }
                    }
                }
            }`,
    },
    filter: {
      //url: `${window.baseURL}enterprise/readbuyablesinorder/?type=Order Template`,
      url: `${window.baseURL}graphql-product`,
      query: `{
                readOrderTemplate({params}) {
                    edges {
                        node {
                            ID
                            BuyableID
                        }
                    }
                }
            }`,
    },
    fullRange: {
      url: `${window.baseURL}graphql-product`,
      query: `{
                searchResult({params}) {
                    pageInfo {
                        totalCount
                        hasNextPage
                        hasPreviousPage
                    }
                    edges {
                        node {
                            MiraklProduct
                            ContainerType
                            ProductType
                            Brand
                            BrandCountry
                            BrandRegion
                            CasePrice
                            CaseRRP
                            Created
                            DisplayPrice
                            DisplayRRP
                            EnCreated
                            HasCocktails
                            ID
                            InternalItemID
                            ItemsInCase
                            LiquorStyle
                            LoyaltyPoints
                            ReSizedDefaultImage
                            ReSizedProductListingImage
                            SellByPackageOnly
                            SoldAt
                            StockForAdelaide
                            StockForMelbourne
                            StockForSydney
                            StockForBrisbane
                            StockForCairns
                            CombinedStock
                            TranslationRedemptionID
                            SupplierLoyaltyPoints
                            BonusLoyaltyPoints
                            PointsExcludedFromRetail
                            Title
                            UnitPrice
                            UnitRRP
                            URLSegment
                            Varietal
                            WebCategory
                            WholesaleUnitsPerCase
                            WetTax
                            SplitPackSize
                            CaseCostMelbourne
                            CaseCostSydney
                            CaseCostAdelaide
                            CaseCostBrisbane
                            CaseCostCairns
                            Sort
                            Supplier
                            SupplierExternalID
                            SplitCaseSurchargesJSON
                            IsCoreRange
                            LongtermOOS {
                              edges {
                                node {
                                  ID
                                  Location {
                                    ID
                                  }
                                  Date
                                }
                              }
                            }
                        }
                    }
                }
            }`,
    },
    add: {
      //url: `${window.baseURL}orders/additem/`,
      url: `${window.baseURL}graphql-product`,
      query: `mutation ($BuyableID: Int!){
                createWishListItem(BuyableID: $BuyableID) {
                    ID
                    Title
                    Buyable {
                        ... on Product {
                            ID
                        }
                    }
                }
            }`,
    },
    remove: {
      //url: `${window.baseURL}orders/removeItem/`
      url: `${window.baseURL}graphql-product`,
      query: `mutation {
                deleteWishListItemByBuyable({params}) {
                    ID
                    Title
                    Buyable {
                        ... on Product {
                            ID
                        }
                    }
                }
            }`,
    },
    removeProductFromOrderTemplate: {
      //url: `${window.baseURL}orders/removeItem/`
      url: `${window.baseURL}graphql-product`,
      query: `mutation($BuyableID: Int!) {
                deleteWishListItemByBuyable(BuyableID: $BuyableID) {
                    ID
                    Title
                    Buyable {
                        ... on Product {
                            ID
                        }
                    }
                }
            }`,
    },
  },

  quoteTemplate: {
    listing: {
      //url: `${window.baseURL}enterprise/readbuyablesinorder/?type=Order Template`,
      url: `${window.baseURL}graphql-product`,
      query: `query readSalesQoute($filters: SalesQuoteFilterInput) {
        readSalesQuotes(Filters: $filters) {
            edges {
                node {
                    ID
                    Prospect
                    CustomerName
                    PlacedBy {
                        Title
                        Company
                        ID
                    }
                    IsArchived
                    CompetitorName
                    Status
                    CustomerEmail
                    ApprovedBy{
                      Email
                      ID
                    }
                    Created
                    PromotionZones {
                      edges {
                        node {
                          ID
                          Title
                          DefaultDiscountMemberID
                          Members {
                            edges {
                              node {
                                ID
                                Warehouse {
                                  ID
                                  Code
                                }
                              }
                            }
                          }
                        }
                      }
                    }            
                    Customer {
                        ID
                        Title
                        Company
                        Email
                        EnCity
                        EnState
                        InternalItemID
                        Warehouse {
                            ID
                            Code
                        }
                    }
                }
            }
        }
      }`,
    },
    itemsListing: {
      //url: `${window.baseURL}enterprise/readbuyablesinorder/?type=Order Template`,
      url: `${window.baseURL}graphql-product`,
      query: `query readSalesQuoteItems($SaleQuoteID: String!) {
        readSalesQuoteItems(SaleQuoteID: $SaleQuoteID) {
          pageInfo{
            totalCount
          }
          edges {
            node {
              ID
              Title
              Notes
              CompetitorPrice
              CompetitorEmail
              Frequency
              Savings
              SupplierDiscountPerCase
              SaleQuoteItemUnitPrice
              Quantity
              WetTax
              ParamountDiscount
              FrontLinePrice
              CompetitorPriceDisabled
              WholesaleListPrice
              Gp
              MarginUnit
              CostUnit
              Product {
                ... on Product {
                  ID
                  Title
                  URLSegment
                  InternalItemID
                  Brand
                  Varietal
                  LiquorStyle
                  BrandRegion
                  BrandCountry
                  DisplayRRP
                  DisplayPrice
                  ReSizedDefaultImage
                  ReSizedProductListingImage
                  UnitRRP
                  UnitPrice
                  CaseRRP
                  CasePrice
                  SoldAt
                  StockForMelbourne
                  StockForSydney
                  StockForAdelaide
                  StockForBrisbane
                  StockForCairns
                  WholesaleUnitsPerCase
                  ItemsInCase
                  SellByPackageOnly
                  WebCategory
                  Created
                  EnCreated
                  HasCocktails
                  LoyaltyPoints
                  SupplierLoyaltyPoints
                  BonusLoyaltyPoints
                  PointsExcludedFromRetail
                  WetTax
                  SplitPackSize
                  CaseCostMelbourne
                  CaseCostSydney
                  CaseCostAdelaide
                  CaseCostBrisbane
                  CaseCostCairns
                  ContainerType
                  ProductType
                  Supplier
                }
              }
            }
          }
        }
      }`,
    },
    saleQuotelisting: {
      //url: `${window.baseURL}enterprise/readbuyablesinorder/?type=Order Template`,
      url: `${window.baseURL}graphql-product`,
      query: `query readSalesQoute($filters: SalesQuoteFilterInput) {
        readSalesQuotes(Filters: $filters) {
            edges {
                node {
                    ID
                    PlacedBy {
                        Title
                        Company
                    }
                    IsArchived
                    CompetitorName
                    Status
                    CustomerEmail
                    CustomerName
                    ApprovedBy{
                      Email
                      ID
                    }
                    Created
                    PromotionZones {
                      edges {
                        node {
                          ID
                          DefaultDiscountMemberID
                          Title
                        }
                      } 
                    }
                    Customer {
                        ID
                        Title
                        Company
                        Warehouse {
                            ID
                            Code
                        }
                    }
                }
            }
        }
    }`,
    },
  },
  cart: {
    update: {
      // url: `${window.baseURL}orders/updateorder/`,
      url: `${window.baseURL}graphql-enterprise`,
      query: `mutation($Buyables: [CartItemInput]!) {
                addCartOrderItems(Buyables: $Buyables) {
                    ID
                    #InternalItemID
                    DiscountTotal
                    ShippingTotal
                    SubTotal
                    TaxTotal
                    Total
                    Items {
                        edges {
                            node {
                                ID
                                UnitPrice
                                TotalPrice
                                CalculatedSubTotalPrice
                                TotalUnitItems
                                SupplierPromotionDiscount
                                SupplierPromotionType

                                # TotalPrice
                                # TotalItems
                                # CalculatedTotalTax
                                # InternalItemID
                                # ItemsInCase
                                # BundleSize
                                BundleType
                                Buyable {
                                    ... on Product {
                                      ID
                                      InternalItemID
                                      WebCategory
                                      Title
                                      Brand
                                      URLSegment
                                      ReSizedDefaultImage
                                      UnitRRP
                                      UnitPrice
                                      CaseRRP
                                      CasePrice
                                      SoldAt
                                      StockForMelbourne
                                      StockForSydney
                                      StockForAdelaide
                                      StockForBrisbane
                                      StockForCairns
                                      CombinedStock
                                      TranslationRedemptionID
                                      WholesaleUnitsPerCase
                                      ItemsInCase
                                      SellByPackageOnly
                                      LoyaltyPoints
                                      SupplierLoyaltyPoints
                                      BonusLoyaltyPoints
                                      PointsExcludedFromRetail
                                      Created
                                      EnCreated
                                      ContainerType
                                      ProductType
                                    }
                                }
                                # ReSizedProductListingImage
                            }
                        }
                    }
                }
            }`,
    },

    updateItemQuantity: {
      // url: `${window.baseURL}orders/updateorder/`,
      url: `${window.baseURL}graphql-enterprise`,
      query: `mutation ($ID: ID!, $TotalUnitItems: Int) {
              updateCartOrderItem(ID: $ID, TotalUnitItems: $TotalUnitItems) {
                ID
                Items {
                  edges {
                    node {
                      ID
                      Title
                      BundleSize
                      UnitPrice
                      TotalPrice
                      TotalUnitItems
                      CalculatedSubTotalPrice
                    }
                  }
                }
              }
            }
`,
    },
    deleteItem: {
      // url: `${window.baseURL}orders/updateorder/`,
      url: `${window.baseURL}graphql-enterprise`,
      query: `mutation($ID: ID!) {
                deleteCartOrderItem(ID: $ID) {
                    ID
                    Items {
                        edges {
                            node {
                                ID
                                Title
                                BundleSize
                                UnitPrice
                                TotalPrice
                                TotalUnitItems
                                CalculatedSubTotalPrice
                            }
                        }
                    }
                }
            }`,
    },
    deleteAllItems: {
      // url: `${window.baseURL}orders/updateorder/`,
      url: `${window.baseURL}graphql-enterprise`,
      query: `mutation($IDs: [ID]) {
              deleteCartOrderItem(IDs: $IDs) {
                ID
                Items {
                  edges {
                    node {
                      ID
                      Title
                      BundleSize
                      UnitPrice
                      TotalPrice
                      TotalUnitItems
                      CalculatedSubTotalPrice
                    }
                  }
                }
              }
            }`,
    },

    list: {
      // url: `${window.baseURL}api/orders/?type=Cart&memberid={customerID}`,
      url: `${window.baseURL}graphql-enterprise`,
      query: `query readOneCart {
              readOneCart {
                ID
                SubTotal
                ShippingTotal
                TaxTotal
                Total
                DiscountTotal
                AssignedShippingID
                PointsEarned
                StatusCredits
                Items {
                  edges {
                    node {
                      MiraklProduct
                      ID
                      UnitPrice
                      TotalPrice
                      CalculatedSubTotalPrice
                      TotalUnitItems
                      SupplierPromotionDiscount
                      SupplierPromotionType
                      BundleType
                      Created
                      DisplayImage
                      PointsEarned
                      StatusCredits
                      PointsSpent
                      Buyable {
                        ... on Product {
                          ID
                          InternalItemID
                          WebCategory
                          Title
                          Brand
                          URLSegment
                          ReSizedDefaultImage
                          UnitRRP
                          UnitPrice
                          CaseRRP
                          CasePrice
                          SoldAt
                          StockForMelbourne
                          StockForSydney
                          StockForAdelaide
                          StockForBrisbane
                          StockForCairns
                          CombinedStock
                          TranslationRedemptionID
                          WholesaleUnitsPerCase
                          ItemsInCase
                          SellByPackageOnly
                          LoyaltyPoints
                          SupplierLoyaltyPoints
                          BonusLoyaltyPoints
                          PointsExcludedFromRetail
                          Created
                          EnCreated
                          SplitPackSize
                          Redeemable
                          ContainerType
                          ProductType
                          IsCoreRange
                          SupplierExternalID
                        }
                      }
                    }
                  }
                }
                ShippingAddress {
                  ID
                  FullAddress
                  PostalCode
                  State
                }
                AppliedDiscountCoupon {
                  ... on DiscountCouponHolder {
                    ID
                    DiscountCoupons {
                      edges {
                        node {
                          Title
                          InternalItemID
                          Discount
                          Type
                        }
                      }
                    }
                  }
                }
                AppliedSurchargeTotal
                AppliedSurcharges{
                  nodes{
                   ID
                   Title
                   CalculatedUnitPrice
                   CalculatedTotalPrice
                  }
                }
              }
            }`,
    },
  },
  saleQuote: {
    approveSalesQuote: {
      // url: `${window.baseURL}orders/updateorder/`,
      url: `${window.baseURL}graphql-product`,
      query: `mutation($ID: Int! , $IsArchived: Boolean , $IsDeleted: Boolean) {
                approveSalesQuoteMutation(ID:$ID , IsArchived: $IsArchived , IsDeleted: $IsDeleted) {
                    ID
                    Status
                }
            }`,
    },
    create: {
      url: `${window.baseURL}graphql-product`,
      query: `mutation(
                $CustomerEmail: String
                $CustomerID: Int
                $CustomerName: String
                $Prospect: Boolean
                $Status: String
                $SalesQuoteItems: [SalesQuoteItemsInputType]
                $PromotionZones: [ID]
              ) {
                CreateSalesQuotesCreateMutation(
                  CustomerEmail: $CustomerEmail
                  CustomerID: $CustomerID
                  CustomerName: $CustomerName
                  Prospect: $Prospect
                  Status: $Status
                  SalesQuoteItems: $SalesQuoteItems
                  PromotionZones: $PromotionZones
                ) {
                  ID
                  Customer {
                    ... on ElvantiWholesaler {
                      ID
                    }
                  }
                  CustomerEmail
                  SalesQuoteItems {
                    edges {
                      node {
                        ID
                        CompetitorPrice
                        Quantity
                        CompetitorEmail
                        FrontLinePrice
                      }
                    }
                  }
                }
}`,
    },
    update: {
      url: `${window.baseURL}graphql-product`,
      query: `mutation(
                $CustomerEmail: String
                $CustomerName: String
                $CustomerID: Int
                $ID:Int
                $Prospect: Boolean
                $Status: String
                $SalesQuoteItems: [SalesQuoteItemsInputType]
                $PromotionZones: [ID]
              ) {
                CreateSalesQuotesCreateMutation(
                  CustomerEmail: $CustomerEmail
                  CustomerName: $CustomerName
                  CustomerID: $CustomerID
                  ID:$ID
                  Prospect: $Prospect
                  Status: $Status
                  SalesQuoteItems: $SalesQuoteItems
                  PromotionZones: $PromotionZones
                ) {
                  ID
                  Customer {
                    ... on ElvantiWholesaler {
                      ID
                    }
                  }
                  CustomerEmail
                  CustomerName
                  SalesQuoteItems {
                    edges {
                      node {
                        ID
                        CompetitorPrice
                        Quantity
                        CompetitorEmail
                        FrontLinePrice
                      }
                    }
                  }
                }
}`,
    },
  },
  cart3pl: {
    update: {
      url: `${window.baseURL}orders/updateorder/`,
    },
    request: {
      url: `${window.baseURL}graphql`,
      query: `{
                readElvantiOrders(type:"Cart") {
                    edges {
                        node {
                            OrderItems {
                                edges {
                                    node {
                                        BuyableID
                                    }
                                }
                            }
                        }
                    }
                }
            }`,
    },
  },
  supplierDiscount: {
    listing: {
      url: `${window.baseURL}graphql-product`,
      query: `query {
              readDiscounts {
                edges {
                  node {
                    ID
                    Title
                    FromDate
                    ToDate
                    Customers {
                      edges {
                        node {
                          ID
                          Email
                          FirstName
                          Surname
                        }
                      }
                    }
                    Items {
                      edges {
                        node {
                          DiscountType
                          Amount
                          Product {
                            ... on Product {
                              ID
                              Title
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }`,
      // url: `${window.baseURL}graphql`,
      // query: `{
      //     readElvantiPromotions(type:"discount") {
      //         edges {
      //             node {
      //                 ID
      //                 Title
      //                 StartDate
      //                 EndDate
      //                 PromotionType
      //                 IsSupplierPromotion
      //                 PromotionCustomers {
      //                     edges {
      //                         node {
      //                             ID
      //                             FirstName
      //                             Surname
      //                         }
      //                     }
      //                 }
      //             }
      //         }
      //     }
      // }`
    },
    create: {
      url: `${window.baseURL}graphql-product`,
      query: `mutation ($Title: String!, $FromDate: String!, $ToDate: String!, $Items: [DiscountItemsInputType]!, $Customers: [ID]!) {
              createDiscount(Title: $Title, FromDate: $FromDate, ToDate: $ToDate, Items: $Items, Customers: $Customers) {
                ID
                Title
                FromDate
                ToDate
                Items {
                  edges {
                    node {
                      ID
                    }
                  }
                }
              }
            }`,
    },
    update: {
      url: `${window.baseURL}promotions/creatediscount`,
      // url: `${window.baseURL}discounts/updatediscount`,
    },
    detail: {
      url: `${window.baseURL}graphql`,
      query: `{
                readElvantiPromotions(id: {id}) {
                    edges {
                        node {
                            ID
                            Title
                            StartDate
                            EndDate
                            MinPurchase
                            PromotionType
                            IsSupplierPromotion
                            PromotionalProducts {
                                edges {
                                    node {
                                        ID
                                        ProductID
                                        CaseAmount
                                        ProductTitle
                                    }
                                }
                            }
                            PromotionCustomers {
                                edges {
                                    node {
                                        ID
                                        FirstName
                                        Surname
                                    }
                                }
                            }
                        }
                    }
                }
            }`,
    },
  },
  supplierPromotion: {
    create: {
      // url: `${window.baseURL}promotions/createpromotion`,
      url: `${window.baseURL}graphql-product`,
      query: `mutation ($Title: String!, $FromDate: String!, $ToDate: String!, $Customers: [ID]!, $BuyProducts: [ID]!, $GetProducts: [ID]!, $BuyQty: Int, $GetQty: Int) {
              createSupplierPromotion(Title: $Title, FromDate: $FromDate, ToDate: $ToDate, Customers: $Customers, BuyProducts: $BuyProducts, GetProducts: $GetProducts, GetQty: $GetQty, BuyQty: $BuyQty) {
                ID
                ClassName
                LastEdited
                Created
                InternalItemID
                ExternalItemID
                Title
                FromDate
                ToDate
                BuyQty
                GetQty
              }
            }`,
    },
    list: {
      url: `${window.baseURL}graphql-product`,
      query: `{
              readSupplierPromotions {
                edges {
                  node {
                    ID
                    Title
                    FromDate
                    ToDate
                    BuyQty
                    GetQty
                    Customers {
                      edges {
                        node {
                          ID
                          Email
                          FirstName
                          Surname
                        }
                      }
                    }
                    GetProducts {
                      edges {
                        node {
                          ID
                          Title
                        }
                      }
                    }
                    BuyProducts {
                      edges {
                        node {
                          ID
                          Title
                        }
                      }
                    }
                  }
                }
              }
            }`,
    },
    details: {
      url: `${window.baseURL}graphql-product`,
      query: `{
                readOneSupplierPromotion(ID: {id}) {
                    ID
                    Title
                    FromDate
                    ToDate
                    BuyQty
                    GetQty
                    Customers {
                      edges {
                        node {
                          ID
                          Email
                          FirstName
                          Surname
                        }
                      }
                    }
                    GetProducts {
                      edges {
                        node {
                          ID
                          Title
                        }
                      }
                    }
                    BuyProducts {
                      edges {
                        node {
                          ID
                          Title
                        }
                      }
                    }
                }
            }`,
    },
    bonusPromotionDetails: {
      url: `${window.baseURL}graphql`,
      query: `{
                readOneElvantiBonusPromotion(ID: {id}) {
                    BuyQuantity
                    GetQuantity
                    PromotionType
                    ID
                }
            }`,
    },
  },
  dealBuilder: {
    create: {
      url: `${window.baseURL}graphql-product`,
      query: `mutation ($ID:ID,$Title: String!, $Type: String!, $LimitPerCustomer: String, $QuantityDependentOffPercentage:Float!, $QuantityDependentOffValue:Float!, $PromotionZoneID: [ID], $FromDate: String!, $ToDate: String!, $Customers: [ID]!, $BuyProducts: [ID], $GetProducts: [ID], $BuyQty: Int, $GetQty: Int, $Items: [DealBuilderSubmissionItemsInputType], $RemovedProductsIDs: [ID]) { createDealBuilderSubmission(ID:$ID,Title: $Title, Type: $Type, LimitPerCustomer:$LimitPerCustomer, QuantityDependentOffPercentage:$QuantityDependentOffPercentage,
                QuantityDependentOffValue:$QuantityDependentOffValue,PromotionZoneID: $PromotionZoneID  FromDate: $FromDate, ToDate: $ToDate, Customers: $Customers, BuyProducts: $BuyProducts, GetProducts: $GetProducts, GetQty: $GetQty, BuyQty: $BuyQty, Items: $Items,RemovedProductsIDs: $RemovedProductsIDs) {
                ID
              }
            }`,
    },
    compare: {
      url: `${window.baseURL}graphql-product`,
      query: `query(
        $ID: ID
        $Title: String!
        $Type: String!
        $QuantityDependentOffPercentage: Float!
        $QuantityDependentOffValue: Float!
        $PromotionZoneID: [ID]
        $FromDate: String!
        $ToDate: String!
        $Customers: [ID]!
        $BuyProducts: [ID]
        $GetProducts: [ID]
        $BuyQty: Int
        $GetQty: Int
        $Items: [DealBuilderSubmissionItemsInputType]
      ) {
        compareDealDiscount (
          ID: $ID
          Title: $Title
          Type: $Type
          QuantityDependentOffPercentage: $QuantityDependentOffPercentage
          QuantityDependentOffValue: $QuantityDependentOffValue
          PromotionZoneID: $PromotionZoneID
          FromDate: $FromDate
          ToDate: $ToDate
          Customers: $Customers
          BuyProducts: $BuyProducts
          GetProducts: $GetProducts
          GetQty: $GetQty
          BuyQty: $BuyQty
          Items: $Items
        ) {
          Discounts
          PromoDeals
        }
      }`,
    },
    delete: {
      url: `${window.baseURL}graphql-product`,
      query: `mutation ($ID: ID!) { deleteDealBuilderSubmission(ID: $ID) {
                ID
              }
            }`,
    },
    detail: {
      url: `${window.baseURL}graphql-product`,
      query: `{
                readOneDealBuilderSubmission(ID:{dealBuilderID}) {
                  ID
                  Title
                  Type
                  LimitPerCustomer
                  FromDate
                  ToDate
                  QuantityDependentOffPercentage
                  QuantityDependentOffValue
                  PromotionZones {
                    edges {
                      node {
                        ID
                        Title
                        DefaultDiscountMemberID
                        Members {
                          edges {
                            node {
                              ID
                              Warehouse {
                                ID
                                Code
                              }
                            }
                          }
                        }
                      }
                    }
                  }          
                  Customers {
                    edges {
                      node {
                        ID
                        Email
                        FirstName
                        Surname
                        EnCity
                        EnState
                        Company
                        InternalItemID
                      }
                    }
                  }
                  BuyQty
                  GetQty
                  BuyProducts {
                    edges {
                      node {
                        ID
                        Title
                        InternalItemID
                      }
                    }
                  }
                  GetProducts {
                    edges {
                      node {
                        ID
                        Title
                        InternalItemID
                      }
                    }
                  }
                  Items {
                    edges {
                      node {
                        DiscountType
                        Amount
                        Product {
                          ... on Product {
                            ID
                            Title
                            InternalItemID
                            ItemsInPackage
                            WholesaleUnitsPerCase
                            ItemsInCase
                            SellByPackageOnly
                            WetTax
                          }
                        }
                      }
                    }
                  }
                }
            }`,
    },
    list: {
      url: `${window.baseURL}graphql-product`,
      query: `{
              readAllDealBuilderSubmission {
                edges {
                  node {
                    ID
                    Title
                    Type
                    LimitPerCustomer
                    FromDate
                    ToDate
                    QuantityDependentOffPercentage
                    QuantityDependentOffValue
                    PromotionZones {
                      edges {
                        node {
                          ID
                          Title
                        }
                      }
                    }
            
                    Customers {
                      edges {
                        node {
                          ID
                          Email
                          FirstName
                          Surname
                          EnCity
                          EnState
                          Company
                          InternalItemID
                        }
                      }
                    }
                    BuyQty
                    GetQty
                    BuyProducts {
                      edges {
                        node {
                          ID
                          Title
                          InternalItemID
                        }
                      }
                    }
                    GetProducts {
                      edges {
                        node {
                          ID
                          Title
                          InternalItemID
                        }
                      }
                    }
                    Items {
                      edges {
                        node {
                          DiscountType
                          Amount
                          Product {
                            ... on Product {
                              ID
                              Title
                              InternalItemID
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }`,
    },
  },
  orderStatus3pl: {
    listing: {
      url: `${window.baseURL}graphql`,
      query: `{
                readPlOrders(memberid:{supplierID}) {
                    edges {
                        node {
                            CustomerName,
                            DeliverySuburb,
                            ID,
                            Placed,
                            Reference,
                            Status,
                            Total
                        }
                    }
                }
            }`,
    },
    detail: {
      url: `${window.baseURL}graphql`,
      query: `{
                readPlOrders(memberid:{supplierID}, id:{orderID}) {
                    edges {
                        node {
                            ID,
                            Placed,
                            Reference,
                            ShippingTotal,
                            TaxTotal,
                            SubTotal,
                            Total,
                            CustomerName,
                            OrderItems {
                                edges {
                                    node {
                                        ID,
                                        Title,
                                        DisplayImageLink,
                                        InternalItemID,
                                        Quantity,
                                        Tax,
                                        UnitPrice,
                                        Discount,
                                        TotalPrice,
                                        BuyableID
                                    }
                                }
                            }
                        }
                    }
                }
            }`,
    },
  },
  members: {
    createConfirmDeliveryDetails: {
      url: `${window.baseURL}graphql`,
      query: `mutation createDeliveryConfirmation($DP_FirstName:String!, $DP_Surname:String! , $DP_ContactNumber:String! $DP_Email:String! $DP_PreferredDeliveryDay:String! $DP_PreferredDeliveryTimes:String!, $BN_FirstName:String!,$BN_Surname:String!,$BN_ContactNumber:String!,$BN_Email:String!,$FD_FirstName:String!,$FD_Surname:String!,$FD_ContactNumber:String!,$FD_Email:String!,$AP_FirstName:String!,$AP_Surname:String!,$AP_ContactNumber:String!,$AP_Email:String!)
              {
                createDeliveryConfirmation(DP_FirstName:$DP_FirstName, DP_Surname:$DP_Surname, DP_ContactNumber:$DP_ContactNumber, DP_Email:$DP_Email, DP_PreferredDeliveryDay:$DP_PreferredDeliveryDay, DP_PreferredDeliveryTimes:$DP_PreferredDeliveryTimes, BN_FirstName:$BN_FirstName, BN_Surname:$BN_Surname, BN_ContactNumber:$BN_ContactNumber,BN_Email:$BN_Email,FD_FirstName:$FD_FirstName,FD_Surname:$FD_Surname,FD_ContactNumber:$FD_ContactNumber,FD_Email:$FD_Email,AP_FirstName:$AP_FirstName,AP_Surname:$AP_Surname,,AP_ContactNumber:$AP_ContactNumber,,AP_Email:$AP_Email)
                {
                  DP_Surname
                  HideDeliveryPopup


                }
              }`,
    },
    createMyAccountInfo: {
      url: `${window.baseURL}graphql`,
      query: `mutation updateMemberInfo ($Input: UpdateMemberInput!){
              updateMemberInfo(Input: $Input)
                {
                  ID
                }
              }`,
    },
    createMember: {
      url: `${window.baseURL}graphql`,
      query: `mutation  ($Input: CreateMemberInput!){
        createMember(Input: $Input)
                {
                  ID
                }
              }`,
    },
    updateChildMemberInfo: {
      url: `${window.baseURL}graphql`,
      query: `mutation  ($Input: UpdateMemberInput!){
        updateMemberInfo(Input: $Input)
                {
                  ID
                }
              }`,
    },
    updateDoItLaterCountMemberInfo: {
      url: `${window.baseURL}graphql`,
      query: `mutation  ($Input: UpdateMemberInput!){
        updateMemberInfo(Input: $Input)
                {
                  ID
                }
              }`,
    },
    deleteMemberMutation: {
      url: `${window.baseURL}graphql`,
      query: `mutation  ($ID:Int!){
        deleteMemberMutation(ID: $ID)
                {
                  ID
                }
              }`,
    },
    detail: {
      url: `${window.baseURL}graphql`,
      query: `{
                readSilverStripeMembers(id:{memberID}) {
                    edges {
                        node {
                            ID
                            FirstName
                            Surname
                            Email
                        }
                    }
                }
            }`,
    },
    wholesaleDetail: {
      url: `${window.baseURL}graphql`,
      query: `{
                readWholesaleMembers(id:{memberID}) {
                    edges {
                        node {
                            ID
                            FirstName
                            Surname
                            Email
                            DefaultSavedCreditCardID
                            DefaultDeliveryAddressID
                            State
                        }
                    }
                }
            }`,
    },
    update: {
      url: `${window.baseURL}graphql`,
      query: `mutation {mutationParams} {
                updateMemberInfo({inputParams}) {
                    ID
                    NotifyRestockViaEmail
                    NotifyRestockViaSMS
                    AccountReminderViaSMS
                    HideQLDCustomerPopup
                    IsConsolidationEnabled
                }
            }`,
    },
    create: {
      url: `${window.baseURL}graphql`,
      query: `mutation {mutationParams} {
                createMember({inputParams}) {
                    ID
                }
            }`,
    },
    delete: {
      url: `${window.baseURL}graphql`,
      query: `mutation deleteMemberMutation($ID:Int!) {
                deleteMemberMutation(ID: $ID) {
                    ID
                }
            }`,
    },
    creditCards: {
      //url: `${window.baseURL}enterprise/readsavedcreditcards`,
      url: `${window.baseURL}graphql`,
      query: `{
          readCreditCards(MemberID: {memberID}, Gateway: {gateway}) {
                    edges {
                        node {
                            ID
                            CardName
                            Title
                            Month
                            Year
                        }
                    }
                }
            }`,
    },
    creditCardMyAccount: {
      //url: `${window.baseURL}enterprise/readsavedcreditcards`,
      url: `${window.baseURL}graphql`,
      query: `{
          readCreditCards(MemberID: {memberID}, Gateway: {gateway} , PageType: {pageType}) {
                    edges {
                        node {
                            ID
                            CardName
                            Title
                            Month
                            Year
                        }
                    }
                }
            }`,
    },
    newCreditCard: {
      //url: `${window.baseURL}payments/savecard/`,
      url: `${window.baseURL}graphql`,
      query: ` mutation ($Number: String!, $Cvv: String, $ExpiryMonth: Int, $ExpiryYear: Int, $Gateway: String, $Token: String, $CardName: String, $CardReference: String, $CardIssuer: String) {
                createCreditCard(Input: {
                  Number: $Number,
                  Cvv: $Cvv,
                  ExpiryMonth: $ExpiryMonth,
                  ExpiryYear: $ExpiryYear,
                  Gateway: $Gateway,
                  Token: $Token,
                  CardName: $CardName,
                  CardReference: $CardReference,
                  CardIssuer: $CardIssuer
                }) {
                    ID
                    CardName
                    Title
                }
            }`,
    },
    removeCreditCard: {
      //url: `${window.baseURL}wholesale/removecard/?cardid={cardID}`,
      url: `${window.baseURL}graphql`,
      query: `mutation DeleteCreditCard($IDs: [ID]!) {
                deleteCreditCard(IDs: $IDs) {
                    ID
                }
            }`,
    },
    selectDefaultCreditCard: {
      url: `${window.baseURL}graphql`,
      query: `mutation UpdateCreditCard($SavedCreditCardID: String!) {
                updateMemberInfo(Input: { SavedCreditCardID: $SavedCreditCardID }) {
                    ID
                    SavedCreditCard {
                        ID
                    }
                }
            }`,
    },
    addresses: {
      url: `${window.baseURL}graphql-core`,
      query: `{
                readAddresss(PurchasingUser: {PurchasingUser}) {
                    edges {
                        node {
                            ID
                            FullAddress
                            UnitNumber
                            StreetNumber
                            StreetNumber_2
                            StreetName
                            Address
                            Suburb
                            State
                            PostalCode
                            Country
                            EnDefaultAddress
                        }
                    }
                }
            }`,
    },
    addressesGraphQL: {
      url: `${window.baseURL}graphql`,
      query: `
            {
                readMysiteDeliveryAddresss(memberid: {memberID}) {
                    edges {
                        node {
                            ID
                            Created
                            UnitNumber
                            Address
                            StreetNumber
                            StreetNumber_2
                            StreetName
                            Suburb
                            State
                            PostalCode
                            Country
                        }
                    }
                }
            }`,
    },
    newAddress: {
      url: `${window.baseURL}graphql-core`,
      query: `mutation ($MemberID: ID, $UnitNumber: String, $StreetNumber: String, $StreetName: String, $Suburb: String, $State: String, $PostalCode: String, $Country: String) {
                  createAddress(Input: {MemberID: $MemberID, UnitNumber: $UnitNumber, StreetNumber: $StreetNumber, StreetName: $StreetName, Suburb: $Suburb, State: $State, PostalCode: $PostalCode, Country: $Country}, PurchasingUser: {PurchasingUser}) {
                    ID
                    UnitNumber
                    StreetNumber
                    StreetName
                    Suburb
                    State
                    PostalCode
                    Country
                  }
                }
            `,
    },
    removeAddress: {
      url: `${window.baseURL}graphql-core`,
      query: `mutation ($ID: ID){
              deleteAddress (IDs: [$ID], PurchasingUser: {PurchasingUser}) {
                ID
              }
            }`,
    },
    setDefaultAddress: {
      url: `${window.baseURL}graphql`,
      query: `mutation ($DeliveryAddressID: String) {
                  updateMemberInfo (Input: {DeliveryAddressID: $DeliveryAddressID} ) {
                    ID
                  }
            }`,
    },
    orderOnBehalf: {
      // url: `${window.baseURL}api/enterprise/orderOnBehalf`,
      url: `${window.baseURL}graphql-enterprise`,
      query: `mutation OrderOnBehalf($MemberID: ID, $LocationID: Int) {
                orderOnBehalf(MemberID: $MemberID, LocationID: $LocationID) {
                    ID
                    FirstName
                    Surname
                    Email
                    Company
                    EnCity
                    InternalItemID
                    Is3PL
                    DeliveryAddress {
                      ... on ElvantiAddress {
                        ID
                        State
                      }
                    }
                    BillingAddress {
                      ... on ElvantiAddress {
                        ID
                      }
                    }
                    SavedCreditCard {
                      ... on ElvantiSavedCreditCard {
                        ID
                      }
                    }
                    Warehouse {
                      Code
                    }
                }
            }`,
    },
    impersonateUser: {
      url: `${window.baseURL}graphql-core`,
      query: `mutation ImpersonateUser($MemberID: Int!) {
        ImpersonateUser(MemberID: $MemberID){
          ID
          FirstName
          Email
        }
      }`,
    },
  },
  customers3pl: {
    listing: {
      url: `${window.baseURL}graphql`,
      query: `{
                readPlCustomers(memberid:{supplierID}) {
                    edges {
                        node {
                            ID,
                            Name,
                            UnitNumber,
                            Address,
                            Suburb,
                            Postcode,
                            State,
                            ContactName,
                            ContactNumber
                        }
                    }
                }
            }`,
    },
    detail: {
      url: `${window.baseURL}graphql`,
      query: `{
                readPlCustomers(memberid:{supplierID}, id:{customerID}) {
                    edges {
                        node {
                            ID
                            Name
                            Address
                            Suburb
                            Postcode
                            State
                            ContactName
                            ContactNumber
                        }
                    }
                }
            }`,
    },
  },
  backorder: {
    reminder: {
      url: `${window.baseURL}graphql`,
      query: `mutation RemindMeProductMutation($productID:Int!, $remindMe:Boolean!) {
                RemindMeProductMutation(ProductID: $productID, RemindMe: $remindMe){
                  RemindMe
              }
            }`,
    },
    list: {
      // url: `${window.baseURL}api/orders/?type=Back+Order&memberid={customerID}`,
      url: `${window.baseURL}graphql-enterprise`,
      query: `query readOneBackOrder {
              readOneBackOrder {
                ID
                Items {
                  edges {
                    node {
                      MiraklProduct
                      ID
                      UnitPrice
                      TotalPrice
                      CalculatedSubTotalPrice
                      TotalUnitItems
                      BundleType
                      Created
                      Buyable {
                        ... on Product {
                          ID
                          InternalItemID
                          WebCategory
                          Title
                          Brand
                          URLSegment
                          ReSizedDefaultImage
                          UnitRRP
                          UnitPrice
                          CaseRRP
                          CasePrice
                          SoldAt
                          StockForMelbourne
                          StockForSydney
                          StockForAdelaide
                          StockForBrisbane
                          StockForCairns
                          WholesaleUnitsPerCase
                          ItemsInCase
                          SellByPackageOnly
                          Created
                          EnCreated
                          ContainerType
                          ProductType
                          Supplier
                          SupplierExternalID
                        }
                      }
                    }
                  }
                }
              }
            }`,
    },
    deleteItem: {
      url: `${window.baseURL}graphql-enterprise`,
      query: `mutation deleteBackOrderItem($IDs: [ID]) {
              deleteBackOrderItem(IDs: $IDs) {
                ID
              }
            }`,
    },
  },
  permanentBackorder: {
    list: {
      // url: `${window.baseURL}api/orders/?type=Back+Order&memberid={customerID}`,
      url: `${window.baseURL}graphql-enterprise`,
      query: `query readOnePermanentBackOrder {
              readOnePermanentBackOrder {
                ID
                Items {
                  edges {
                    node {
                      ID
                      UnitPrice
                      TotalPrice
                      TotalUnitItems
                      BundleType
                      Created
                      DisplayImage
                      Buyable {
                        ... on Product {
                          ID
                          InternalItemID
                          WebCategory
                          Title
                          Brand
                          URLSegment
                          ReSizedDefaultImage
                          UnitRRP
                          UnitPrice
                          CaseRRP
                          CasePrice
                          SoldAt
                          StockForMelbourne
                          StockForSydney
                          StockForAdelaide
                          StockForBrisbane
                          StockForCairns
                          WholesaleUnitsPerCase
                          ItemsInCase
                          Created
                          EnCreated
                          ContainerType
                          ProductType
                        }
                      }
                    }
                  }
                }
              }
            }`,
    },
    delete: {
      url: `${window.baseURL}graphql-enterprise`,
      query: `mutation ($IDs: [ID]) {
              deletePermanentBackOrderItem(IDs: $IDs) {
                ID
              }
            }`,
    },
  },
  checkout: {
    paymentMethod: {
      url: `${window.baseURL}graphql`,
      query: `{
        readGlobalConfig {
          CheckoutPaymentMethods
          UseCurrentCards
          LastUsedPaymentMethod
          UserTermType
          EnableCCAuthorization
        }
      }`,
    },
    cart: {
      //url: `${window.baseURL}checkout/orders/?type=Cart&memberid={customerID}`,
      url: `${window.baseURL}graphql-enterprise`,
      query: `{
              readOneCart {
                ID
                SubTotal
                ShippingTotal
                TaxTotal
                Total
                DiscountTotal
                AssignedShippingID
                PointsEarned
                StatusCredits
                Items {
                  edges {
                    node {
                      MiraklProduct
                      ID
                      Title
                      UnitPrice
                      TotalPrice
                      CalculatedSubTotalPrice
                      TotalUnitItems
                      SupplierPromotionDiscount
                      SupplierPromotionType
                      BundleType
                      PointsEarned
                      StatusCredits
                      PointsSpent
                      Buyable {
                        ... on Product {
                          ID
                          InternalItemID
                          WebCategory
                          Title
                          Brand
                          Varietal
                          LiquorStyle
                          BrandRegion
                          BrandCountry
                          URLSegment
                          ReSizedDefaultImage
                          WholesaleUnitsPerCase
                          ItemsInCase
                          SellByPackageOnly
                          LoyaltyPoints
                          SupplierLoyaltyPoints
                          BonusLoyaltyPoints
                          PointsExcludedFromRetail
                          SplitPackSize
                          Redeemable
                          WetTax
                          ContainerType
                          ProductType
                          IsCoreRange
                          SupplierExternalID
                        }
                      }
                    }
                  }
                }
                ShippingAddress {
                  ID
                  FullAddress
                  PostalCode
                  State
                }
                AppliedDiscountCoupon {
                  ... on DiscountCouponHolder {
                    ID
                    DiscountCoupons {
                      edges {
                        node {
                          Title
                          InternalItemID
                          Discount
                          Type
                        }
                      }
                    }
                  }
                }
                AppliedSurchargeTotal
                AppliedSurcharges{
                  nodes{
                   ID
                   Title
                   CalculatedUnitPrice
                   CalculatedTotalPrice
                  }
                }
              }
            }`,
    },
    updateCart: {
      url: `${window.baseURL}graphql-enterprise`,
      query: `mutation ($UrgentPickup: Boolean, $UrgentDelivery: Boolean, $DeliveryDate: String, $Notes: String, $Reference: String, $ShippingAddressID: Int, $PaymentMethod: String, $CardID: Int, $PickupEmptyKegs: Boolean, $KegsToPickUp: Int){
              updateCart (Input: {UrgentPickup:$UrgentPickup , UrgentDelivery:$UrgentDelivery  ,DeliveryDate: $DeliveryDate, Reference: $Reference, Notes: $Notes, ShippingAddressID: $ShippingAddressID, PaymentMethod: $PaymentMethod , CardID : $CardID, PickupEmptyKegs: $PickupEmptyKegs, KegsToPickUp: $KegsToPickUp}) {
                ID
                Status
                SubTotal
                ShippingTotal
                TaxTotal
                CreditCardSurcharge
                PointsEarned
                StatusCredits
                Total
                PaymentMethod
                UrgentPickup
                UrgentDelivery
                MinimumDeliveryFee
                ExtraAttribute1
                PrepaidBalanceUsed
                AppliedSurchargeTotal
                AppliedSurcharges{
                   nodes{
                    ID
                    Title
                    CalculatedUnitPrice
                    CalculatedTotalPrice
                  }
                }
              }
            }`,
    },
    updateCartShipping: {
      url: `${window.baseURL}graphql-enterprise`,
      query: `mutation($Input: CartShippingUpdateInputType!) {
              updateCartShipping(Input: $Input) {
                ID
              }
            }`,
    },
    details: {
      url: `${window.baseURL}graphql`,
      query: `{
                readElvantiOrders(type:"Cart", memberid:{customerID}) {
                    edges {
                        node {
                            ID,
                            ShippingTotal,
                            TaxTotal,
                            SubTotal
                            Total,
                        }
                    }
                }
            }`,
    },
    deliveryDates: {
      url: `${window.baseURL}graphql-core`,
      query: `{
                readAppDeliveryDates(limit: 20) {
                    edges {
                        node {
                            Date
                            Day
                            Available
                            ConsolidationDay
                        }
                    }
                }
            }`,
    },
    processPayment: {
      //url: `${window.baseURL}checkout/process/`,
      url: `${window.baseURL}graphql-enterprise`,
      query: `mutation ($OrderID: ID!, $PaymentMethod: String!, $CardID: ID, $Token: String, $Gateway: String, $SaveCard: Boolean, $Card: CreditCardInputType){
              payForOrder (OrderID: $OrderID, PaymentMethod: $PaymentMethod, CardID: $CardID, Token: $Token, Gateway: $Gateway, SaveCard: $SaveCard, Card: $Card){
                ID
                Status
                PaymentRedirectURL
              }
            }`,
    },
    processPaymentPoliPay: {
      //url: `${window.baseURL}checkout/process/`,
      url: `${window.baseURL}graphql-enterprise`,
      query: `mutation ($OrderID: ID!, $PaymentMethod: String!, $CardID: ID, $Token: String, $Gateway: String, $SaveCard: Boolean, $Card: CreditCardInputType){
              payForOrder (OrderID: $OrderID, PaymentMethod: $PaymentMethod, CardID: $CardID, Token: $Token, Gateway: $Gateway, SaveCard: $SaveCard, Card: $Card){
                ID
                Status
                PaymentRedirectURL
              }
            }`,
    },
    applyCoupon: {
      url: `${window.baseURL}graphql-enterprise`,
      query: `mutation($Code: String!) {
        applyCoupon(Code: $Code) {
          ID
          DiscountTotal
          Total
        }
      }`,
    },
    removeAppliedCoupon: {
      url: `${window.baseURL}graphql-enterprise`,
      query: `mutation {
        removeAppliedCoupon{
          ID
          DiscountTotal
        }
      }`,
    },
  },
  advancedShippingNotice: {
    readAdvancedShippingNotice: {
      url: `${window.baseURL}graphql`,
      query: `query readAdvancedShippingNotice($Status: String!) {
        readAdvancedShippingNotice(Status: $Status) {
          ID
          DCLocation
          ReferenceNumber
          ContactEmail
          FreightSolution
          PickUpLocation
          ReqDateOfPickUp
          DCDeliveryDate
          Description
          AddressLine1
          AddressLine2
          PostCode
          LocationPhone
          LocationEmail
          LoscamPallets
          ChepPallets
          PlainPallets
          Status
          Supplier {
            ID
            Company
          }
        }
      }`,
    },
    readOneAdvancedShippingNotice: {
      url: `${window.baseURL}graphql`,
      query: `query($ID: ID) {
        readOneAdvancedShippingNotice(ID: $ID) {
          ID
          DCLocation
          ReferenceNumber
          ContactEmail
          FreightSolution
          PickUpLocation
          ReqDateOfPickUp
          DCDeliveryDate
          Description
          AddressLine1
          AddressLine2
          Suburb
          PostCode
          LocationPhone
          LocationEmail
          LoscamPallets
          ChepPallets
          PlainPallets
          Status
          AdvancedShippingNoticeItems {
            edges {
              node {
                ID
                Weight
                Carton
                CartonReceived
                Product {
                  ...on Product{
                    ContainerType
                    ProductType
                    ID
                    Title
                    URLSegment
                    InternalItemID
                    Brand
                    Varietal
                    LiquorStyle
                    BrandRegion
                    BrandCountry
                    DisplayRRP
                    DisplayPrice
                    ReSizedDefaultImage
                    UnitRRP
                    UnitPrice
                    CaseRRP
                    CasePrice
                    SoldAt
                    StockForMelbourne
                    StockForSydney
                    StockForAdelaide
                    StockForBrisbane
                    StockForCairns
                    WholesaleUnitsPerCase
                    ItemsInCase
                    SellByPackageOnly
                    WebCategory
                    Created
                    EnCreated
                    HasCocktails
                    LoyaltyPoints
                    SupplierLoyaltyPoints
                    BonusLoyaltyPoints
                    PointsExcludedFromRetail
                    WetTax
                    SplitPackSize
                    CaseCostMelbourne
                    CaseCostSydney
                    CaseCostAdelaide
                    CaseCostBrisbane
                    CaseCostCairns
                    CasesPerLayer
                    CasesPerPallet
                    ItemWeight
                    MLPerunit
                  }
                }
              }
            }
          }
        }
      }`,
    },
    createShippingNotice: {
      url: `${window.baseURL}graphql`,
      query: `mutation createAdvancedShippingNotice($Input: AdvancedShippingNoticeInputType) {
        CreateAdvancedShippingNotice(Input: $Input) {
            DCLocation
          }
        }`,
    },
    deleteShippingNotice: {
      url: `${window.baseURL}graphql`,
      query: `mutation deleteAdvanceShippingNotice($ID: ID!, $IsDeleted: Boolean!) {
        deleteAdvancedShippingNotice(ID: $ID, IsDeleted: $IsDeleted) {
          IsDeleted
        }
      }`,
    },
    readAsnPickupLocations: {
      url: `${window.baseURL}graphql`,
      query: `query($LocationID: Int!) {
        readSupplierLocation(LocationID: $LocationID) {
          Address
          Address2
          Supplier
          Vendor
          LocationID
          City
          PostalCode
        }
      }`,
    },
  },
  productMaintenance: {
    detail: {
      url: `${window.baseURL}graphql-product`,
      query: `query {
                readOneProductMaintenanceRequest(ProductID: {ProductID}) {
                    InternalItemID
                    SupplierProductRef
                    Name
                    Brand
                    Description
                    Size
                    SplitPackSize
                    Title
                    ContainerType
                    Style
                    Country
                    Region
                    WebCategory
                    Varietals
                    Abv
                    ColdStorage
                    Package
                    UnitsPerCase
                    CaseUPC
                    CarrierUPC
                    UnitUPC
                    ProductType
                    CodeDateType
                    CaseWeightInKG
                    Height
                    Width
                    Length
                    CasesPerPallet
                    CasesPerLayer
                    GST
                    WET
                    Approved
                    EditCompleted
                    Removed
                    StockAvailableMelbourne
                    StockAvailableSydney
                    StockAvailableBrisbane
                    StockAvailableCairns
                    StockAvailableAdelaide
                    Status
                    Is3PLOnly
                    SellByCaseOnly
                    TrackVintages
                    MarketingTag
                    HideOnWeb
                    CaseCostAdelaide
                    CaseCostBrisbane
                    CaseCostCairns
                    CaseCostMelbourne
                    CaseCostSydney
                    Images {
                        edges {
                            node {
                                ReSizedProductGridImage
                                ReSizedProductListingImage
                                ReSizedProductDetailImage
                                ReSizedProductImageCustom1
                                ReSizedProductImageCustom2
                                ReSizedProductImageCustom3
                                ID
                            }
                        }
                    }
                    Product {
                      ... on Product {
                        StockForSydney
                        StockForCairns
                        StockForBrisbane
                        StockForMelbourne
                        StockForAdelaide
                      }
                    }
                }
            }`,
    },
    detailImages: {
      url: `${window.baseURL}graphql`,
      query: `{
                readMysiteSupplierProductEditRequests(supplierid:{supplierID}, productid:{productID}) {
                    edges {
                        node {
                            Image1 {
                                ... on SilverStripeImage {
                                    ID
                                    Link
                                }
                            }
                            Image2 {
                                ... on SilverStripeImage {
                                    ID
                                    Link
                                }
                            }
                            Image3 {
                                ... on SilverStripeImage {
                                    ID
                                    Link
                                }
                            }
                            Image4 {
                                ... on SilverStripeImage {
                                    ID
                                    Link
                                }
                            }
                            Image5 {
                                ... on SilverStripeImage {
                                    ID
                                    Link
                                }
                            }
                        }
                    }
                }
            }`,
    },
    removeImage: {
      //url: `${window.baseURL}product-maintenance/removeimage/`,
    },
    update: {
      url: `${window.baseURL}graphql-product`,
      query: `mutation ($ProductID: Int!, $Input: ProductMaintenanceInputType) {
                createProductMaintenanceRequest(ProductID: $ProductID, Input: $Input) {
                    LastEdited
                    Created
                    SupplierProductRef
                    Name
                    Brand
                    Description
                    Size
                    SplitPackSize
                    Title
                    ContainerType
                    Style
                    Country
                    Region
                    WebCategory
                    Varietals
                    Abv
                    ColdStorage
                    Package
                    UnitsPerCase
                    CaseUPC
                    CarrierUPC
                    UnitUPC
                    ProductType
                    CodeDateType
                    CaseWeightInKG
                    Height
                    Width
                    Length
                    MarketingTag
                    TrackVintages
                    CasesPerPallet
                    CasesPerLayer
                    GST
                    WET
                    StockAvailableAdelaide
                    StockAvailableBrisbane
                    StockAvailableCairns
                    StockAvailableMelbourne
                    StockAvailableSydney
                    Approved
                    EditCompleted
                    Removed
                    Status
                    Is3PLOnly
                    SellByCaseOnly
                    HideOnWeb
                  }
            }`,
    },
  },
  report: {
    customReport: {
      create: {
        url: `${window.baseURL}graphql`,
        query: `mutation createCustomReport($Input: CustomReportInputType) {
          createCustomReport(Input: $Input) {
            ID
            FileURL
            IsCompleted
          }
        }`,
      },
      read: {
        url: `${window.baseURL}graphql`,
        query: `query readOneCustomReport($ID: Int!) {
          readOneCustomReport(ID: $ID) {
            ID
            FileURL
            IsCompleted
          }
        }`,
      },
    },

    supplierHistory: {
      url: `${window.baseURL}graphql-product`,
      query: `query {
              readSupplierHistoryReport {
                ProductID
                ProductName
                InvoiceID
                PublicPDFLink
                Brand
                Date
                SupplierID
                Supplier
                CustomerID
                Company
                Units
                Cases
                Vol
              }
            }`,
    },
    supplierStock: {
      url: `${window.baseURL}graphql-product`,
      query: `query {
              readSupplierStockReport {
                ProductID
                ProductName
                Location
                CasesOnHand
                PendingSales
                CasesOnOrder
                MonthsStock
                SalesPerMonth
                Status
              }
            }`,
    },
    supplierCostFile: {
      url: `${window.baseURL}graphql`,
      query: `query($For3PL: Boolean) {
        readConsumerPriceIndexReport (For3PL: $For3PL) {
          ReportJSON
        }
      }`,
    },
    supplierSalesReport: {
      url: `${window.baseURL}graphql-product`,
      query: `query readSalesByProduct{
        readSupplierSalesByProductReport{
          Location
          DeliveryDate
          Brand
          Vol
          productName
          Cases
          Company
          Group
          Territory
          City
          PostCode
        }
      }`,
    },
    supplierReadTransBinReport: {
      url: `${window.baseURL}graphql`,
      query: `query($FromDate: String, $ToDate: String) {
        readBinTransReport(FromDate: $FromDate, ToDate: $ToDate) {
          Date
          ProductID
          ProductName
          TransactionType
          InvoicePO
          Customer
          Quantity
        }
      }`,
    },
    supplierSalesVenueReport: {
      url: `${window.baseURL}graphql-product`,
      query: `query readSalesByVenue{
        readSupplierSalesByVenueTypeReport{
          Location
          VenueType
          Brand
          Vol
          DistributionCount
          Cases
        }
      }`,
    },
    supplierSales: {
      url: `${window.baseURL}graphql-product`,
      // Stephy: Still waiting for new endpoint. For now I will put it as this.
      query: `query {
              readSupplierHistoryReport {
                ProductID
                ProductName
                InvoiceID
                PublicPDFLink
                Brand
                Date
                SupplierID
                Supplier
                CustomerID
                Company
                Units
                Cases
                Vol
              }
            }`,
    },
    dollarChargeRCTI: {
      url: `${window.baseURL}graphql-core`,
      query: `query readSupplierDollarChargeRCTIReport($FromDate: String, $ToDate: String) {
              readSupplierDollarChargeRCTIReport(FromDate: $FromDate, ToDate: $ToDate) {
                edges {
                  node {
                    Location
                    DeliveryDate
                    InvoiceID
                    CustomerName
                    City
                    PostalCode
                    ProductID
                    ProductName
                    RCTIDescription
                    ChargeType
                    InvoiceNum
                    NumUnits
                    Cases
                    CaseSellPrice
                    PickFee
                    BuyPrice
                  }
                }
              }
            }`,
    },
    dollarChargeBilling: {
      url: `${window.baseURL}graphql-core`,
      query: `query readSupplierDollarChargeBillingReport($FromDate: String, $ToDate: String) {
              readSupplierDollarChargeBillingReport(FromDate: $FromDate, ToDate: $ToDate) {
                edges {
                  node {
                    ChargeDate
                    InvoiceID
                    PONum
                    CustomerName
                    City
                    PostalCode
                    ChargeZone
                    ProductID
                    ProductName
                    Pallets
                    Layers
                    Cases
                    Kegs
                    Units
                    TotalPickCharge
                    TotalFreightCharge
                  }
                }
              }
            }
        `,
    },
    percentageRCTI: {
      url: `${window.baseURL}graphql-core`,
      query: `query readSupplierPercentageChargeRCTIReport(
        $FromDate: String
        $ToDate: String
      ) {
        readSupplierPercentageChargeRCTIReport(FromDate: $FromDate, ToDate: $ToDate) {
          edges {
            node {
              Location
              ChargeDate
              InvoiceID
              CustomerName
              ProductID
              ProductName
              RCTIDescription
              InvoiceNum
              PurchaseID
              NumUnits
              Cases
              CaseSellPrice
              FeePerCase
              CaseBuyPrice
              TotalBuyPrice
            }
          }
        }
      }
          `,
    },
    percentageChargeBilling: {
      url: `${window.baseURL}graphql-core`,
      query: `query readSupplierPercentageChargeBillingReport(
              $FromDate: String
              $ToDate: String
            ) {
              readSupplierPercentageChargeBillingReport(
                FromDate: $FromDate
                ToDate: $ToDate
              ) {
                edges {
                  node {
                    DeliveryDate
                    InvoiceID
                    PONum
                    Location
                    CustomerName
                    ProductID
                    ProductName
                    Units
                    Cases
                    CaseSellPrice
                    ChargePerCase
                    TotalCharges
                  }
                }
              }
            }
        `,
    },
    supplierRateCardList: {
      url: `${window.baseURL}graphql`,
      query: `query readSupplierRateCardList {
              readSupplierRateCardList {
                edges {
                  node {
                    RateCode
                    CaseFreightRate
                    KegFreightRate
                    LayerFreightRate
                    PalletFreightRate
                    MinimumFreight
                    PostCode
                  }
                }
              }
            }
       `,
    },
    supplierRateCard: {
      url: `${window.baseURL}graphql`,
      query: `query SupplierRateCardTypeCreator {
              readSupplierRateCardSummary {
                ThreePLType
                BillingFrequency
                FreightTier
                PickFeePercent
                PickFeePallet
                PickFeeLayer
                PickFeeKeg
                PickFeeCase
                DeadStockCharge
                PickFeeUnit
                OverstockCharge
                OutofDateCharge
                ColdStoreCharge
                MinimumMonthlyFee
                EstablishmentFee
                NewLineFee
                AmbientStorageFeev
                SSCCLabelFee
                LabelBarcodeFee
                UrgentOrderFee
                PalletBreakdownFee
                ManualLabourPerHour
                ContainerPallet20FT
                ContainerHand20FT
                ContainerPallet40FT
                ContainerHand40FT
                FreightPalletPercentThreshold
                FreightLayerPercentThreshold
                EmptyKegPickup
                BreakageDiscountPercent
                LocalCaseDestructionFee
                CertifiedCaseDestructionFee
                CertifiedKegDestructionFee
              }
            }
        `,
    },
    supplierOutOfStockReport: {
      url: `${window.baseURL}graphql-core`,
      query: `query {
              readSupplierOutOfStockReport {
                edges {
                  node {
                    DeliveryDate
                    OrderType
                    CustomerName
                    Invoice
                    POD
                    WebOrder
                    Reason
                    Warehouse
                    ProductID
                    ProductName
                    PONum
                    Ordered
                    Received
                    OutOfStockQty
                  }
                }
              }
            }
       `,
    },
    supplierPurchasesReport: {
      url: `${window.baseURL}graphql-core`,
      query: `query {
              readSupplierPurchasesReport {
                edges {
                  node {
                    TimeCreated
                    PurchaseID
                    Warehouse
                    ReceiveDate
                    PONum
                    ProductID
                    ProductName
                    Status
                    PublicPDFLink
                    OrderedCases
                    ReceivedCases
                  }
                }
              }
            }
       `,
    },
    supplierUpdatePricing: {
      url: `${window.baseURL}graphql`,
      query: `mutation CreateCPIReport($ReportJSON: String!,$For3PL: Boolean!) {
        createCPIReport(ReportJSON: $ReportJSON, For3PL: $For3PL) {
          ReportJSON
        }
      }`,
    },
  },
  superWholesaler: {
    forceLogin: {
      url: `${window.baseURL}api/forcelogin/?wholesalerid={wholesalerid}&memberid={memberid}`,
    },
  },
  autocomplete: {
    customerGroups: {
      url: `${window.baseURL}graphql`,
      query: `{
                readElvantiProductPriceGroups(q:"{keyword}", limit:15) {
                    edges {
                        node {
                            ID,
                            Title
                        }
                    }
                }
            }`,
    },
    wholesalers: {
      // url: `${window.baseURL}api/members/?q={keyword}&customersonly=1&limit=15`,
      url: `${window.baseURL}graphql-enterprise`,
      query: `query searchWholesaler($q: String, $limit: Int) {
                searchWholesaler(q: $q, CustomersOnly: true, limit: $limit) {
                    ID
                    Warehouse {
                      ID
                      Code
                    }
                    FirstName
                    Surname
                    EnCity
                    EnLocationID
                    Email
                    EnEmail
                    Is3PL
                    Company
                    InternalItemID
                    EnState
                }
            }`,
    },

    threeplCustomers: {
      // url: `${window.baseURL}api/members/?q={keyword}&customersonly=1&limit=15`,
      url: `${window.baseURL}graphql-enterprise`,
      query: `query searchWholesaler($q: String, $limit: Int) {
                searchWholesaler(q: $q, Only3PLCustomers: true, limit: $limit) {
                    ID
                    Warehouse {
                      ID
                      Code
                    }
                    FirstName
                    Surname
                    EnCity
                    DefaultLocationForSupplier
                    Email
                    EnEmail
                    Is3PL
                    Company
                    InternalItemID
                    EnState
                }
            }`,
    },

    members: {
      url: `${window.baseURL}api/members/?q={keyword}&limit=15`,
      // url: `${window.baseURL}graphql`,
      // query: `{
      //     readSilverStripeMembers(q:"{keyword}", limit:15) {
      //         edges {
      //             node {
      //                 ID
      //                 FirstName
      //                 Surname
      //                 Email
      //             }
      //         }
      //     }
      // }`
    },
    customers3pl: {
      // url: `${window.baseURL}api/plcustomers/?q={keyword}&includeCustomers=1&limit=15`,
      url: `${window.baseURL}graphql-enterprise`,
      query: `query searchWholesaler($q: String, $limit: Int) {
                searchWholesaler(q: $q, limit: $limit) {
                    ID
                    FirstName
                    Surname
                    EnEmail
                    Email
                    Is3PL
                    Company
                    InternalItemID
                }
            }`,
    },
    zone: {
      url: `${window.baseURL}graphql-product`,
      query: `query readAllZones($q: String, $limit: Int) {
                readSupplierPromotionZones(q: $q, limit: $limit) {
                  edges {
                    node {
                      ID
                      Title
                      DefaultDiscountMemberID
                      Members{
                        edges{
                          node{
                            ID
                          }
                        }
                      }
                    }
                  }
                }
              }`,
    },
    suppliers: {
      // url: `${window.baseURL}api/members/?q={keyword}&customersonly=1&limit=15`,
      url: `${window.baseURL}graphql`,
      query: `query searchSupplier($q: String, $limit: Int) {
        searchSupplier(q: $q, limit: $limit) {
          ID
          Warehouse {
            ID
            Code
          }
          FirstName
          Surname
          EnCity
          Email
          EnEmail
          Is3PL
          Company
          InternalItemID
          EnState
        }
      }`,
    },
    wholesalerZones: {
      url: `${window.baseURL}graphql-product`,
      query: `query readAllZones($q: String, $limit: Int) {
        readSupplierPromotionZones(q: $q, limit: $limit) {
          edges {
            node {
              ID
              Title
              DefaultDiscountMemberID
              Members{
                edges{
                  node{
                    ID
                    Warehouse {
                      ID
                      Code
                    }
                  }
                }
              }
            }
          }
        }
      }`,
    },
  },
  promoDeals: {
    getDealsforProductSku: {
      url: `${window.baseURL}graphql-product`,
      query: `query readAllDeals($InternalItemID: ID!){
        readProductPromoDeals(InternalItemID: $InternalItemID){
          PromoDeals
        }
      }`,
    },
  },
  threePlOrders: {
    listing: {
      url: `${window.baseURL}graphql-core`,
      query: ` query readSupplierOrder($FromDate: String, $ToDate: String) {
        readSupplierOrder(FromDate: $FromDate, ToDate: $ToDate) {
          edges {
            node {
              DeliveryDate
              OrderType
              CustomerName
              Reference
              WebOrder
              StatusPretty
              Warehouse
              ProductID
              POD
              ProductName
              Ordered
              Received
              TrackingLink
              PONum
              TotalCases
              TotalKegs
              Address
            }
          }
        }
      }
      `,
    },
  },
  threePlCustomer: {
    create: {
      url: `${window.baseURL}graphql-core`,
      query: `mutation ($Input: CreateUpdateThreePLCustomerInput!) {
                createUpdateThreePLCustomer(Input:$Input){
                  ID
                  DefaultLocationForSupplier
                  Company
                  DeliveryAddress {
                    ... on Address {
                      ID
                      State
                    }
                  }
                  BillingAddress {
                    ... on Address {
                      ID
                    }
                  }
                  SavedCreditCard {
                    ... on ElvantiSavedCreditCard {
                      ID
                    }
                  }
                  Email
                  EnCity
                  FirstName
                  InternalItemID
                  Is3PL
                  Surname
                  Warehouse {
                    ID
                  }
                }
            }`,
    },

    listing: {
      url: `${window.baseURL}graphql-core`,
      query: ` query readAllThreePLCustomers ($filters:ThreePLCustomerFilterInput) {
        readAllThreePLCustomers(Filters:$filters){
          edges{
            node{
              ID
              DefaultLocationForSupplier
              InternalItemID
              EnTermID
              Terms
              Company
              Mobile
              Email
              IsResidential
              EnPostCode
              LiquorLicenseNumber
              EnState
              DeliveryDays
              DeliveryTime
              DeliveryNotes
              DeliveryAddress {
                ... on Address {
                  ID
                  Address
                  State
                  PostalCode
                  Suburb
                  StreetName
                  StreetNumber
                  UnitNumber
                }
              }
            }
          }
        }
      }
      `,
    },

    toggleActivateCustomer: {
      url: `${window.baseURL}graphql-core`,
      query: ` mutation ($CustomerID: Int!){
              toggleActivateThreePLCustomer(CustomerID :$CustomerID ){
                ID
                IsActivated
              }
            }
      `,
    },
    readCreditTermsOptions: {
      url: `${window.baseURL}graphql`,
      query: ` query readConfig {
        readGlobalConfig {
          CreditTermsOptions {
            TermID
            Terms
          }
        }
      }`,
    },
  },
  threePlProductMaintenance: {
    add: {
      url: `${window.baseURL}graphql-core`,
      query: ` mutation mutate($Input: UpdateProductAvailabilityType!){
                updateSupplierProductAvailability( Input: $Input ){
                ID
              }
            }
      `,
    },
    readSupplierProductAvailabilities: {
      url: `${window.baseURL}graphql-core`,
      query: ` query readSupplierProductAvailabilities{
            readSupplierProductAvailabilities{

              edges{
                node{
                  Product {
                    ... on Product {
                      ID
                      Title
                    }
                  }
                  StockAvailableMelbourne
                  StockAvailableSydney
                  StockAvailableCairns
                  StockAvailableBrisbane
                  StockAvailableAdelaide
                }
              }
            }

      }    `,
    },
  },
  threePlCreditAccount: {
    debitList: {
      url: `${window.baseURL}graphql`,
      query: `query
                {
                  readSupplierInvoiceReport{
                    InvoiceDoc
                    TransactionID
                    TransactionReference
                    Balance
                    Date
                    Receipt
                    Debit
                  }
                }`,
    },
    creditList: {
      url: `${window.baseURL}graphql`,
      query: `query
                {
                  readSupplierPurchasesReport{
                    TransactionID
                    InvoiceNum
                    ReceiveDate
                    TransactionReference
                    PurchaseTotal
                    Payment
                    Balance
                    PurchaseDoc
                  }
                }`,
    },
    transactionDetails: {
      url: `${window.baseURL}graphql`,
      query: `query($PoInvoiceNum: String!) {
        readRCTITransactionDetail(PoInvoiceNum: $PoInvoiceNum) {
          edges {
            node {
              DeliveryDate
              OrderType
              CustomerCompany
              InvoiceID
              TranslationInvoiceNum
              Location
              ProductID
              ProductName
              PONum
              PoInvoiceNum
              Ordered
              NumUnits
            }
          }
        }
      }`,
    },
    billingCharges: {
      url: `${window.baseURL}graphql`,
      query: `query($InvoiceID: String!) {
        readBillingCharges(InvoiceID: $InvoiceID) {
          edges {
            node {
              Location
              ChargeType
              BillingProductName
              InvoiceID
              InvoiceNum
              Date
              Company
              ProductName
              Address
              City
              PostalCode
              ChargeZone
              Quantity
              NumUnits
              Cases
              Kegs
              Layers
              Pallets
              YearWeek
              Rate
              Fee
            }
          }
        }
      }`,
    },
  },
  threePlStockOnHand: {
    list: {
      url: `${window.baseURL}graphql-product`,
      query: `query {
              readSupplierStockReport {
                ProductID
                ProductName
                Location
                CasesOnHand
                PendingSales
                CasesOnOrder
                MonthsStock
                SalesPerMonth
                Status
              }
            }`,
    },
  },
  threePlAtRiskStock: {
    list: {
      url: `${window.baseURL}graphql`,
      query: `query
                {
                  readLowStockReport{
                    Location
                    ProductID
                    ProductName
                    ExpirationDate
                    Vintage
                    Status
                    SOHSales
                    Last4WeeksSalesCases
                    AverageWeeklySalesCases
                  }
                }`,
    },
  },

  checkkoutShippingMethods: {
    readShippingMethods: {
      url: `${window.baseURL}graphql-enterprise`,
      query: `query readShippingMethods{
        readAvailableShippingMethods{
          ID
          Title
          HandlingFee
          Total
          EstimatedDelivery
          IsTaxable
          AllowNotes
        }
      }`,
    },
  },

  threePlFreightCalculator: {
    url: `${window.baseURL}graphql`,
    query: `query($LocationID: Int!, $PostCode: Int!, $Suburb: String!, $KegFreightQuantity: Int, $CaseFreightQuantity: Int) {
      readThreePLFreightCalculatorReport(LocationID: $LocationID, PostCode: $PostCode, Suburb: $Suburb, KegFreightQuantity: $KegFreightQuantity, CaseFreightQuantity: $CaseFreightQuantity) {
        SupplierID
        Quarantine
        PostCode
        City
        FreightTier
        RateCode
        PickFeeCase
        PickFeeKeg
        CaseFreightRate
        KegFreightRate
        MinimumFreight
        CasePickFee
        KegPickFee
        CaseFreight
        KegFreight
        Total3PLInvoice
        TotalParamountInvoice
      }
    }`,
  },
  threePlReadSuburbs: {
    url: `${window.baseURL}graphql`,
    query: `query($LocationID: Int!, $PostCode: String!) {
      readSuburbs(LocationID: $LocationID, PostCode: $PostCode) {
        ID
        PostCode
        City
      }
    }
    `,
  },
  viewStatementPdfLink: {
    url: `${window.baseURL}get_statement`,
  },
  formBuilderSubmit: {
    url: `${window.baseURL}form/submit`,
  },
}
